(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.projects', [
        	'app.projects.stages',
            'app.projects.hours'
    	])
        .config(config)
        .run(run);

        /** @ngInject */
        function config($stateProvider)
        {
            // Navigation
            $stateProvider.state('app.projects', {
                url      : '/projects',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/projects/projects.html',
                        controller : 'ProjectsController as vm'
                    }
                },
                data: {
                  /*permissions: {
                    only: 'listarProyectos',
                    redirectTo: 'app.dashboard'
                  }*/
                }               
            })
            $stateProvider.state('app.my-projects', {
                url      : '/my-projects',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/projects/my-projects.html',
                        controller : 'MyProjectsController as vm'
                    }
                },
                data: {
                  /*permissions: {
                    only: 'listarProyectos',
                    redirectTo: 'app.dashboard'
                  }*/
                }               
            })            
            .state('app.projects.cu', {
                url      : '/cu/{id}',
                views    : {
                    'content@app'                       : {
                        templateUrl: 'app/main/projects/cu/cu-projects.html',
                        controller : 'CUProjectsController as vm'
                    }
                },
                data: {
                },              
                resolve: {
                    Item: ['$stateParams','Project',function($stateParams, Project) {
                        var _id = $stateParams.id;
                        if (_id) {
                            return Project.get({id: _id}).$promise;
                        } else {
                            return new Project();
                        }
                    }]
                }
            });
        }        


	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        // Navigation
	        msNavigationService.saveItem('projects', {
	        	
	            title    : 'Proyectos',
	            icon 	 : 'icon-folder', 
	            weight   : 3,
                           
	        }); 

            msNavigationService.saveItem('projects.list', {
                title: 'Proyectos',
                icon: 'icon-folder',
                state: 'app.projects',
                weight: 1,
                hidden: function ()
                {
                    return !authSrv.hasPermission('listarProyectos');
                }
            });  

            msNavigationService.saveItem('projects.my', {
                title: 'Mis Proyectos',
                icon: 'icon-folder',
                state: 'app.my-projects',
                weight: 2
            });                       	    	
	    }        
})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('CUHoursController', Controller);

    /** @ngInject */
    function Controller($mdDialog,ProjectHour,User,item,me, $log)
    {
        var vm = this;
        angular.extend(vm,{
            title: angular.isDefined(item.id) ? 'Editar carga' : 'Cargar Hs',
            item: new ProjectHour(item),
            users: [],
            projects: [],
            hours: [],
            me: me,
            closeDialog: closeDialog,
            save: save,
            changeUser: changeUser
        });
        //////////

        init();

        function init() {
            for(var i = 0.5; i < 13; i+= 0.5) {
                vm.hours.push(i);
            }
            if (vm.item.date) {
                vm.item.date = moment(vm.item.date).toDate();    
            }


            if (!vm.item.id) {
                ProjectHour.usersForLoad(function(resp) {
                    vm.users = resp.items;
                    vm.item.user = resp.items[0];
                    changeUser();
                });
            } else {
                vm.users.push(vm.item.user);
                vm.projects.push(vm.item.project);
            }
        }

        function changeUser() {
            vm.projects = vm.item.user.projects; 
            vm.item.project = vm.projects[0];           
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function save(frm) {
            if (frm.$valid) {
                if (vm.item.id) {
                    vm.item.$update(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                } else {
                    vm.item.$save(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                }
                
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.users', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.users', {
	            url      : '/users',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/users/users.html',
	                    controller : 'UsersController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarUsuarios',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.users.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/users/cu/cu-users.html',
	                    controller : 'CUUsersController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarUsuarios'];
			          	} else {
			            	return ['crearUsuarios'];
			          	}
			        },
			        redirectTo: 'app.users'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','User',function($stateParams, User) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return User.get({id: _id}).$promise;
	                    } else {
	                        return new User();
	                    }
	                }],
	                areas: ['Area', function(Area) {
	                	return Area.query({order:'name'}).$promise.then(function(resp) {
	                		return resp.data.items;
	                	});
	                }],
	                roles: ['Role', function(Role) {
	                	return Role.query({order:'name', perms: false}).$promise.then(function(resp) {
	                		return resp.data.items;
	                	});	                	
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('admin.users', {
	        	title: 'Usuarios',
	        	icon: 'icon-account-multiple',
	        	state: 'app.users',
	        	weight: 1,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarUsuarios');
		        }
	        });
	    }        

})();							
(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('CPUsersController', Controller);

    /** @ngInject */
    function Controller($mdDialog, Item, $log)
    {
        var vm = this;

        // Data
        vm.form = Item;


        // Methods
        vm.closeDialog  = closeDialog;
        vm.submit       = submit;
        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function submit(frm) {
            if (frm.$valid) {
                Item.$changePassword(function() {
                    $mdDialog.hide();
                });
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.suppliers.skills', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.suppliers_skills', {
	            url      : '/admin/skills',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/suppliers/skills/skills.html',
	                    controller : 'SkillsController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarSkills',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.suppliers_skills.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/suppliers/skills/cu/cu-skills.html',
	                    controller : 'CUSkillsController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarSkills'];
			          	} else {
			            	return ['crearSkills'];
			          	}
			        },
			        redirectTo: 'app.suppliers_skills'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','Skill',function($stateParams, Skill) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return Skill.get({id: _id}).$promise;
	                    } else {
	                        return new Skill();
	                    }
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('suppliers.skills', {
	        	title: 'Skills',
	        	icon: 'icon-language-html5',
	        	state: 'app.suppliers_skills',
	        	weight: 2,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarSkills');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.suppliers.skills')
        .factory('Skill', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
        var FINAL_API_URL = API_URL + 'skills/';
        return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false}
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.suppliers.skills')
        .controller('CUSkillsController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv, ToastSrv)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar skill' : 'Crear skill',
            subtitle: false,

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
        }

        function back() {
            $state.go('app.suppliers_skills');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.projects.stages', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.projects_stages', {
	            url      : '/projects/stages',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/projects/stages/stages.html',
	                    controller : 'ProjectStagesController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarEtapasProyecto',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.projects_stages.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/projects/stages/cu/cu-stages.html',
	                    controller : 'CUProjectStagesController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarEtapasProyecto'];
			          	} else {
			            	return ['crearEtapasProyecto'];
			          	}
			        },
			        redirectTo: 'app.projects_stages'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','ProjectStage',function($stateParams, ProjectStage) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return ProjectStage.get({id: _id}).$promise;
	                    } else {
	                        return new ProjectStage();
	                    }
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('projects.stages', {
	        	title: 'Etapas',
	        	icon: 'icon-vector-square',
	        	state: 'app.projects_stages',
	        	weight: 3,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarEtapasProyecto');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.projects.stages')
        .factory('ProjectStage', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'project-stages/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false}
    	});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects.stages')
        .controller('CUProjectStagesController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar etapa' : 'Crear etapa',
            subtitle: false,

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
        }

        function back() {
            $state.go('app.projects_stages');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.projects.hours', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.projects_hours', {
	            url      : '/projects/hours',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/projects/hours/project-hours.html',
	                    controller : 'ProjectHoursController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarHorasProyectos',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        /*.state('app.projects_hours.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/projects/hours/cu/cu-project-hours.html',
	                    controller : 'CUProjectHoursController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
		            	return ['cargarHorasProyectos'];
			        },
			        redirectTo: 'app.projects_hours'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','ProjectHour',function($stateParams, ProjectHour) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return ProjectHour.get({id: _id}).$promise;
	                    } else {
	                        return new ProjectHour();
	                    }
	                }]
	            }
	        })*/;
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {

	        msNavigationService.saveItem('projects.hours', {
	        	title: 'Cargar Hs',
	        	icon: 'icon-vector-square',
	        	state: 'app.projects_hours',
	        	weight: 3,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarHorasProyectos');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.projects.hours')
        .factory('ProjectHour', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'project-hours/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false},
            'usersForLoad': {method: 'POST', url: FINAL_API_URL + 'users-for-load', isArray:false}
    	});

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('CUPurchaseOrdersController', Controller);

    /** @ngInject */
    function Controller($mdDialog,PurchaseOrder,item, $log)
    {
        var vm = this;
        angular.extend(vm,{
            title: angular.isDefined(item.id) ? 'Editar OC' : 'Crear OC',
            item: new PurchaseOrder(item),
            fileUpload: fileUpload,
            closeDialog: closeDialog,
            save: save

        });
        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function fileUpload() {
            angular.element(document.querySelector('#input-file-id')).click();
        }

        function save(frm) {
            if (frm.$valid) {
                if (vm.item.id) {
                    vm.item.$update(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                } else {
                    vm.item.$save(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                }
                
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('CUProjectEstimatesController', Controller);

    /** @ngInject */
    function Controller($mdDialog,ProjectEstimate,item, $log)
    {
        var vm = this;
        angular.extend(vm,{
            title: angular.isDefined(item.id) ? 'Editar Presupuesto' : 'Crear Presupuesto',
            item: new ProjectEstimate(item),
            fileUpload: fileUpload,
            closeDialog: closeDialog,
            save: save

        });
        //////////
        init();
        function init() {
            $log.debug(vm.item);
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function fileUpload() {
            angular.element(document.querySelector('#input-file-id')).click();
        }

        function save(frm) {
            if (frm.$valid) {
                if (vm.item.id) {
                    vm.item.$update(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                } else {
                    vm.item.$save(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                }
                
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('CUProjectCostsController', Controller);

    /** @ngInject */
    function Controller($mdDialog,ProjectCost,Supplier,item, $log)
    {
        var vm = this;
        angular.extend(vm,{
            title: angular.isDefined(item.id) ? 'Editar Costo' : 'Crear Costo',
            item: new ProjectCost(item),
            searchSupplierText: null,
            querySupplierSearch: function(query) {
                return Supplier.query({search:query}).$promise.then(function(response) {
                    return response.data.items;
                });
            },            
            fileUpload: fileUpload,
            closeDialog: closeDialog,
            save: save

        });
        //////////
        init();
        function init() {
            $log.debug(vm.item);
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function fileUpload() {
            angular.element(document.querySelector('#input-file-id')).click();
        }

        function save(frm) {
            if (frm.$valid) {
                if (vm.item.id) {
                    
                    if (vm.item.type === 'S') {
                        vm.item.supplier_id = vm.item.supplier.id;
                    }
                    
                    vm.item.$update(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                } else {
                    if (vm.item.type === 'S') {
                        vm.item.supplier_id = vm.item.supplier.id;
                    }
                    
                    vm.item.$save(function(data) {
                        $log.debug(data);
                        $mdDialog.hide(data);       
                    });

                }
                
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.customers.companies', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.customers_companies', {
	            url      : '/customers/companies',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/customers/companies/companies.html',
	                    controller : 'CompaniesController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarEmpresasClientes',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.customers_companies.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/customers/companies/cu/cu-companies.html',
	                    controller : 'CUCompaniesController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarEmpresasClientes'];
			          	} else {
			            	return ['crearEmpresasClientes'];
			          	}
			        },
			        redirectTo: 'app.customers_companies'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','Company',function($stateParams, Company) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return Company.get({id: _id}).$promise;
	                    } else {
	                        return new Company();
	                    }
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('customers.companies', {
	        	title: 'Empresas',
	        	icon: 'icon-factory',
	        	state: 'app.customers_companies',
	        	weight: 1,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarEmpresasClientes');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.customers.companies')
        .factory('Company', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'customers/companies/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false}
    	});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customers.companies')
        .controller('CUCompaniesController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar empresa' : 'Crear empresa',
            subtitle: false,

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
        }

        function back() {
            $state.go('app.customers_companies');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();	
(function ()
{
    'use strict';

    angular
        .module('app.customers.brands', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.customers_brands', {
	            url      : '/customers/brands',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/customers/brands/brands.html',
	                    controller : 'BrandsController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarMarcasClientes',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.customers_brands.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/customers/brands/cu/cu-brands.html',
	                    controller : 'CUBrandsController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarMarcasClientes'];
			          	} else {
			            	return ['crearMarcasClientes'];
			          	}
			        },
			        redirectTo: 'app.customers.brands'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','Brand',function($stateParams, Brand) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return Brand.get({id: _id}).$promise;
	                    } else {
	                        return new Brand();
	                    }
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('customers.brands', {
	        	title: 'Marcas',
	        	icon: 'icon-web',
	        	state: 'app.customers_brands',
	        	weight: 2,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarMarcasClientes');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.customers.brands')
        .factory('Brand', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'customers/brands/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false}
    	});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customers.brands')
        .controller('CUBrandsController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv, User, Company)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar marca' : 'Crear marca',
            subtitle: false,
            users: [],
            companies: [],

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
            User.query({order:'name'},function(resp) {
                vm.users = resp.data.items;
            });           

            Company.query({order:'name'},function(resp) {
                vm.companies = resp.data.items;
            });
        }

        function back() {
            $state.go('app.customers_brands');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                }, function(e) {
                    ToastSrv.showError(e.data.error);
                });
            } else {
                vm.item.$save(function(data){
                    back();
                }, function(e) {
                    ToastSrv.showError(e.data.error);
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.auth.permissions', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        $stateProvider
        .state('app.auth_permissions', {
            url      : '/auth/permissions',
            views    : {
                'content@app'                       : {
                    templateUrl: 'app/main/auth/permissions/permissions.html',
                    controller : 'PermissionsController as vm'
                }
            },
            data: {
              permissions: {
                only: 'listarPermisos',
                redirectTo: 'app.dashboard'
              }
            }            
        })
        .state('app.auth_permissions.cu', {
            url      : '/cu/{id}',
            views    : {
                'content@app'                       : {
                    templateUrl: 'app/main/auth/permissions/cu/cu-permissions.html',
                    controller : 'CUPermissionsController as vm'
                }
            },
            data: {
              permissions: {
                only: function(transitionProperties){
                    if (transitionProperties.toParams.id !== '') {
                        return ['editarPermisos'];
                    } else {
                        return ['crearPermisos'];
                    }
                },
                redirectTo: 'app.auth_permissions'
              }
            },            
            resolve: {
                Item: ['$stateParams','Permission','$log',function($stateParams, Permission, $log) {
                    var _id = $stateParams.id;
                    if (_id) {
                        return Permission.get({id: _id}).$promise;
                    } else {
                        return new Permission();
                    }
                }]
            }
        });         
        
        $translatePartialLoaderProvider.addPart('app/main/auth/permissions');
    }        
    
    /** @ngInject */
    function run(msNavigationService, authSrv)
    {
        /*msNavigationService.saveItem('admin.permissions', {
            title    : 'Permisos',
            icon     : 'icon-lock-unlocked-outline',
            state    : 'app.auth_permissions',
            weight   : 3,
            hidden: function ()
            {
                return !authSrv.hasPermission('listarPermisos');
            }
        });*/
    }     

})();		
(function ()
{
    'use strict';

    angular
        .module('app.auth.permissions')
        .factory('Permission', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	return $resource(API_URL + 'auth/permissions/:id',{id: '@id'},{
    		'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: API_URL + 'auth/permissions/delete-selected', isArray:false},
            'all':  {method:'GET', url: API_URL + 'auth/permissions/all', isArray:true}
    	});
    }

})();		
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.auth.roles', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider)
    {
        $stateProvider.state('app.auth_roles', {
            url      : '/auth/roles',
            views    : {
                'content@app'                       : {
                    templateUrl: 'app/main/auth/roles/roles.html',
                    controller : 'RolesController as vm'
                }
            },
            data: {
              permissions: {
                only: 'listarRoles',
                redirectTo: 'app.dashboard'
              }
            }             
        })
        .state('app.auth_roles.cu', {
            url      : '/cu/{id}',
            views    : {
                'content@app'                       : {
                    templateUrl: 'app/main/auth/roles/cu/cu-roles.html',
                    controller : 'CURolesController as vm'
                }
            },
            data: {
              permissions: {
                only: function(transitionProperties){
                    if (transitionProperties.toParams.id !== '') {
                        return ['editarRoles'];
                    } else {
                        return ['crearRoles'];
                    }
                },
                redirectTo: 'app.auth_roles'
              }
            },            
            resolve: {
                Item: ['$stateParams','Role','$log',function($stateParams, Role, $log) {
                    var _id = $stateParams.id;
                    if (_id) {
                        return Role.get({id: _id}).$promise;
                    } else {
                        return new Role();
                    }
                }],
                permissions: ['Permission', function(Permission) {
                    return Permission.all().$promise;
                }]
            }
        });  
              
        $translatePartialLoaderProvider.addPart('app/main/auth/roles');
    }    

    /** @ngInject */
    function run(msNavigationService, authSrv)
    {
        msNavigationService.saveItem('admin.roles', {
            title    : 'Roles',
            icon     : 'icon-worker',
            state    : 'app.auth_roles',
            weight   : 2,
            hidden: function ()
            {
                return !authSrv.hasPermission('listarRoles');
            }
        });
    }     
})();		
(function ()
{
    'use strict';

    angular
        .module('app.auth.roles')
        .controller('CUPermissionsController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv, $filter)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar permiso' : 'Crear permiso',
            subtitle: false,

            //METHODS
            save: save,
            back: back,
            makeKey: makeKey
        });

        init();
        //////////

        function init() {
        }

        function back() {
            $state.go('app.auth_permissions');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }

        function makeKey() {
            vm.item.name = $filter('camelize')(vm.item.display_name+vm.item.group);
        }        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.roles')
        .factory('Role', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	return $resource(API_URL + 'auth/roles/:id',{id: '@id'},{
    		'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: API_URL + 'auth/roles/delete-selected', isArray:false}
    	});
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.auth.roles')
        .controller('CURolesController', Controller);

    /** @ngInject */
    function Controller(Item, permissions, $log, $state, authSrv, $filter)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar rol' : 'Crear rol',
            subtitle: false,
            permissions: permissions,

            //METHODS
            save: save,
            back: back,
            makeKey: makeKey,
            selectAll: selectAll
        });

        init();
        //////////

        function init() {
            
        }

        function selectAll(all) {
            if (all) {
                vm.item.permissions = angular.copy(vm.permissions);
            } else {
                vm.item.permissions = [];
            }
        }       

        function back() {
            $state.go('app.auth_roles');
        }

        function makeKey() {
        	vm.item.name = $filter('camelize')(vm.item.display_name).toUpperCase();
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    if (authSrv.hasRole(data)){
                        authSrv.setPermissions(data,true);
                    }                    
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin.areas', [])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config($stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.admin_areas', {
	            url      : '/admin/areas',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/admin/areas/areas.html',
	                    controller : 'AreasController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarAreas',
	                redirectTo: 'app.dashboard'
	              }
	            } 	            
	        })
	        .state('app.admin_areas.cu', {
	            url      : '/cu/{id}',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/admin/areas/cu/cu-areas.html',
	                    controller : 'CUAreasController as vm'
	                }
	            },
	            data: {
	              permissions: {
			        only: function(transitionProperties){
			          	if (transitionProperties.toParams.id !== '') {
			            	return ['editarAreas'];
			          	} else {
			            	return ['crearAreas'];
			          	}
			        },
			        redirectTo: 'app.admin_areas'
	              }
	            },	            
	            resolve: {
	                Item: ['$stateParams','Area',function($stateParams, Area) {
	                    var _id = $stateParams.id;
	                    if (_id) {
	                        return Area.get({id: _id}).$promise;
	                    } else {
	                        return new Area();
	                    }
	                }]
	            }
	        });
	    }        
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('admin.areas', {
	        	title: 'Areas',
	        	icon: 'icon-sitemap',
	        	state: 'app.admin_areas',
	        	weight: 1,
		        hidden: function ()
		        {
		            return !authSrv.hasPermission('listarAreas');
		        }
	        });
	    }        

})();				
(function ()
{
    'use strict';

    angular
        .module('app.admin.areas')
        .factory('Area', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	return $resource(API_URL + 'areas/:id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: API_URL + 'areas/delete-selected', isArray:false}
    	});
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.admin.areas')
        .controller('CUAreasController', Controller);

    /** @ngInject */
    function Controller(Item, $log, $state, authSrv, User)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar área' : 'Crear área',
            subtitle: false,
            users: [],
            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
            User.query({order:'name'},function(resp) {
                $log.debug(resp.data.items);
                vm.users = resp.data.items;
            });
        }

        function back() {
            $state.go('app.admin_areas');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.users')
        .factory('User', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'users/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false},
            'forgotPassword': { method:'POST', url: FINAL_API_URL + 'forgot-password', isArray:false },
            'changePassword': { method:'PUT', url: FINAL_API_URL + ':id/change-password' },
    	});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('CUUsersController', Controller);

    /** @ngInject */
    function Controller(Item, areas, roles, $log, $state, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar usuario' : 'Crear usuario',
            subtitle: false,
            areas: areas,
            roles: roles,

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
        }

        function back() {
            $state.go('app.users');
        }

        function save()
        {

            Item = angular.copy(vm.item);
            
            if (Item.id) {
                Item.$update(function(data){
                    if (authSrv.getUser().id === Item.id) {
                        //Es el usuario loggeado, me fijo si tengo que cambiarle el rol
                        if (authSrv.hasRole(Item.role)) {
                            authSrv.updateUser(Item);    
                            back();
                        } else {
                            authSrv.logout();
                        }
                    } else {
                        back();    
                    }
                    
                });
            } else {
                Item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.suppliers.skills')
        .controller('SkillsController', Controller);

    /** @ngInject */
    function Controller($log, Skill, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Skills',
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: 'id',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.suppliers_skills.cu');
        }

        function edit(item) {
           $state.go('app.suppliers_skills.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Skill.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Skill.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Skill.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();        
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.suppliers', [
        	'app.suppliers.skills'
    	])
        .config(config)
        .run(run);

	    /** @ngInject */
	    function config(msNavigationServiceProvider, $stateProvider)
	    {
	        // Navigation
	        $stateProvider.state('app.suppliers', {
	            url      : '/suppliers',
	            views    : {
	                'content@app'                       : {
	                    templateUrl: 'app/main/suppliers/suppliers.html',
	                    controller : 'SuppliersController as vm'
	                }
	            },
	            data: {
	              permissions: {
	                only: 'listarProveedores',
	                redirectTo: 'app.dashboard'
	              }
	            }	            
	        })        
	        .state('app.suppliers.cu', {
                url      : '/cu/{id}',
                views    : {
                    'content@app'                       : {
                        templateUrl: 'app/main/suppliers/cu/cu-suppliers.html',
                        controller : 'CUSuppliersController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: function(transitionProperties){
                        if (transitionProperties.toParams.id !== '') {
                            return ['editarProveedores'];
                        } else {
                            return ['crearProveedores'];
                        }
                    },
                    redirectTo: 'app.suppliers'
                  }
                },            
                resolve: {
                    Item: ['$stateParams','Supplier','$log',function($stateParams, Supplier, $log) {
                        var _id = $stateParams.id;
                        if (_id) {
                            return Supplier.get({id: _id}).$promise;
                        } else {
                            return new Supplier();
                        }
                    }]
                }
            })
            ;	 
  	         	           	
	    } 
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('suppliers', {
	            title    : 'Proveedores',
	            icon     : 'icon-ticket-account',
	            weight   : 4,
                hidden: function ()
                {
                    return !authSrv.hasAnyPermission(['listarProveedores','listarSkills']);
                }                
	        });  

	        msNavigationService.saveItem('suppliers.list', {
	            title    : 'Proveedores',
	            icon     : 'icon-ticket-account',
	            state    : 'app.suppliers',
	            weight   : 1,
                hidden: function ()
                {
                    return !authSrv.hasPermission('listarProveedores');
                }                
	        });	    	
	    }	           
})();		
(function ()
{
    'use strict';

    angular
        .module('app.suppliers')
        .factory('Supplier', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	return $resource(API_URL + 'suppliers/:id',{id: '@id'},{
    		'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' }
    	});
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.suppliers')
        .controller('CUSuppliersController', Controller);

    /** @ngInject */
    function Controller(Item,Skill, $log, $state, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            title: angular.isDefined(Item.id) ? 'Editar proveedor' : 'Crear proveedor',
            subtitle: false,
            skills: [],

            //METHODS
            save: save,
            back: back
        });

        init();
        //////////

        function init() {
            Skill.query(function(resp) {
                vm.skills = resp.data.items;
            });
        }

        function back() {
            $state.go('app.suppliers');
        }

        function save()
        {
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    back();
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.reports', [
    	])
        .config(config)
        .run(run);

        /** @ngInject */
        function config($stateProvider)
        {
            // Navigation
            $stateProvider.state('app.reports-hours-by-areas', {
                url      : '/reports/hours/areas',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/hours-by.html',
                        controller : 'HoursByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                	by: function() {
                		return 'areas';
                	}
                }               
            })
			.state('app.reports-hours-by-users', {
                url      : '/reports/hours/users',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/hours-by.html',
                        controller : 'HoursByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                	by: function() {
                		return 'users';
                	}
                }               
            })
            .state('app.reports-hours-by-projects', {
                url      : '/reports/hours/projects',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/hours-by.html',
                        controller : 'HoursByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                    by: function() {
                        return 'projects';
                    }
                }               
            })   
            .state('app.reports-hours-by-customers', {
                url      : '/reports/hours/customers',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/hours-by.html',
                        controller : 'HoursByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                    by: function() {
                        return 'customers';
                    }
                }               
            })    
            .state('app.reports-projects-by-stages', {
                url      : '/reports/projects/stages',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/projects-by.html',
                        controller : 'ProjectsByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                    by: function() {
                        return 'stages';
                    }
                }               
            })   
            .state('app.reports-projects-by-states', {
                url      : '/reports/projects/states',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/projects-by.html',
                        controller : 'ProjectsByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                    by: function() {
                        return 'states';
                    }
                }               
            })                                             
            .state('app.reports-projects-by-users', {
                url      : '/reports/projects/users',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/projects-by.html',
                        controller : 'ProjectsByController as vm'
                    }
                },
                data: {
                  permissions: {
                    only: 'listarReportes',
                    redirectTo: 'app.dashboard'
                  }
                }, 
                resolve: {
                    by: function() {
                        return 'users';
                    }
                }               
            })                                             

            ;
        }        


	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        // Navigation
	        msNavigationService.saveItem('reports', {
	        	
	            title    : 'Reportes',
	            icon 	 : 'icon-folder', 
	            weight   : 5,
                hidden: function ()
                {
                    return !authSrv.hasPermission(['listarReportes']);
                }  	            
	        }); 
            msNavigationService.saveItem('reports.hours-by-customers', {
                title: 'Hs por clientes',
                state: 'app.reports-hours-by-customers',
                weight: 1
            });    
            msNavigationService.saveItem('reports.hours-by-areas', {
                title: 'Hs por áreas',
                state: 'app.reports-hours-by-areas',
                weight: 2
            });          
            msNavigationService.saveItem('reports.hours-by-users', {
                title: 'Hs por usuarios',
                state: 'app.reports-hours-by-users',
                weight: 3
            });                	    	
            msNavigationService.saveItem('reports.hours-by-projects', {
                title: 'Hs por proyectos',
                state: 'app.reports-hours-by-projects',
                weight: 3
            });
            msNavigationService.saveItem('reports.reports-projects-by-stages', {
                title: 'Proyectos por etapas',
                state: 'app.reports-projects-by-stages',
                weight: 4
            });   
            msNavigationService.saveItem('reports.reports-projects-by-states', {
                title: 'Proyectos por estados',
                state: 'app.reports-projects-by-states',
                weight: 5
            });                                                
            msNavigationService.saveItem('reports.reports-projects-by-users', {
                title: 'Proyectos por usuarios',
                state: 'app.reports-projects-by-users',
                weight: 6
            }); 
	    }        
})();		
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .factory('ReportSrv', service);

    /** @ngInject */
    function service($q, $http, $log,$httpParamSerializer, API_URL)
    {
    	var API_URL_FULL = API_URL + 'reports/';
        var service = {
        	getHours: getHours,
        	getProjects: getProjects,
            exportXls: exportXls
        };

        function getHours(params) {
            return call(API_URL_FULL+'hours','POST',params);
        }
        function getProjects(params) {
            return call(API_URL_FULL+'projects','POST',params);
        }     

        function exportXls(type,params) {

            window.open(API_URL_FULL + type + '/export?' + $httpParamSerializer(params));
        }   

		function call(path,method,data) {
			var deferred = $q.defer();

			$http({
				method: method,
				url: path,
				data: data || {}
			})
			.then(function (response) {
				if (response.status === 200) {
					deferred.resolve(response.data);
				}
			})
			.catch(function(err) {
				deferred.reject(err);
			});

			return deferred.promise;
		}


        return service;
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects.stages')
        .controller('ProjectStagesController', Controller);

    /** @ngInject */
    function Controller($log, ProjectStage, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Etapas de proyecto',
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: 'id',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.projects_stages.cu');
        }

        function edit(item) {
           $state.go('app.projects_stages.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = ProjectStage.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    ProjectStage.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                ProjectStage.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .factory('PurchaseOrder', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'projects/:project_id/purchase-orders/';
    	return $resource(FINAL_API_URL + ':id',{project_id: '@project_id', id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { 
                method:'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },
            'save':   {
                method: 'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },                
    	});

        function formDataObject (data) {
            var fd = new FormData();
            angular.forEach(data, function(value, key) {
                fd.append(key, (value ? value : ''));
            });
            return fd;
        }          
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .factory('Project', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'projects/';
    	return $resource(FINAL_API_URL + ':id',{id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { method:'PUT' },
            'deleteSelected': {method: 'POST', url: FINAL_API_URL + 'delete-selected', isArray:false},
            'addPO': { 
                method: 'POST',
                url: FINAL_API_URL + + ':id/purchase-orders',
                isArray: false
            }
    	});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .factory('ProjectEstimate', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'projects/:project_id/estimates/';
    	return $resource(FINAL_API_URL + ':id',{project_id: '@project_id', id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { 
                method:'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },
            'save':   {
                method: 'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },            
    	});

        function formDataObject (data) {
            var fd = new FormData();
            angular.forEach(data, function(value, key) {
                fd.append(key, (value ? value : ''));
            });
            return fd;
        }        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .factory('ProjectCost', service);

    /** @ngInject */
    function service($resource,API_URL)
    {
    	var FINAL_API_URL = API_URL + 'projects/:project_id/costs/';
    	return $resource(FINAL_API_URL + ':id',{project_id: '@project_id', id: '@id'},{
            'query':  {method:'GET', isArray:false},
            'update': { 
                method:'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },
            'save':   {
                method: 'POST',
                transformRequest: formDataObject,
                headers: {'Content-Type':undefined, enctype:'multipart/form-data'}
            },            
    	});

        function formDataObject (data) {
            var fd = new FormData();
            angular.forEach(data, function(value, key) {
                fd.append(key, (value ? value : ''));
            });
            return fd;
        }        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects.hours')
        .controller('ProjectHoursController', Controller);

    /** @ngInject */
    function Controller($log,$mdDialog, ProjectHour, DialogSrv, $state, authSrv, DataListsSrv)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Hs por proyectos',
            me: authSrv.getUser(),
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: '-date',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            filters: {
                projects: []
            },            
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            $log.debug(vm.me);
            DataListsSrv.get({
                key: 'projects',
                select: ['id','name']
            }).then(function(data) {
                $log.debug(data);
                vm.filters.projects = data;
                //vm.list.query.project_id = 0;
            });            
            filterList();
        }

        function create() {
            openPODialog({}).then(function(data) {
                if (data) {
                    filterList();
                }
            });
        }

        function edit(item) {
            openPODialog(item).then(function(data) {
                if (data) {
                    angular.extend(item,data);
                }
            });
           
        }        

        function openPODialog(item) {
            return $mdDialog.show({
              controller: 'CUHoursController',
              controllerAs: 'vm',
              templateUrl: 'app/main/projects/hours/dialogs/cu/cu-hours.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:false,
              fullscreen: true,
              locals: {
                item: item,
                me: vm.me
              }              
            });              
        }

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = ProjectHour.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    ProjectHour.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                ProjectHour.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .filter('projectState', filter);

    /** @ngInject */
    function filter(InfoSrv,$q)
    {
        return function (value)
        {
        	var _data = {};
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('CUProjectsController', Controller);

    /** @ngInject */
    function Controller(Item,Company,Brand,User,InfoSrv, $log, $state, authSrv, $mdDialog, DialogSrv, PurchaseOrder, ProjectEstimate, ProjectCost,ProjectStage)
    {
        var vm = this;
        angular.extend(vm,{
            item: Item,
            canFinish: false,
            canEdit: true,
            title: angular.isDefined(Item.id) ? 'Ver/Editar proyecto' : 'Crear proyecto',
            subtitle: false,
            companies: [],
            saving: false,
            brands: [],
            states: [],
            stages: [],
            acUsers: {
                querySearch: function(query) {
                    return User.query({search:query}).$promise.then(function(response) {
                        return response.data.items;
                    });
                }
            },
            //METHODS
            addUser: addUser,
            addStage: addStage,
            addPO: addPO,
            editPO: editPO,
            removePO: removePO,
            addEstimate: addEstimate,
            editEstimate: editEstimate,
            removeEstimate: removeEstimate,
            addCost: addCost,
            editCost: editCost,
            removeCost: removeCost,

            removeItem: removeItem,
            filterItems: filterItems,
            save: save,
            back: back,
            changeCompany: changeCompany,

            grossProfitability: grossProfitability
        });

        init();
        //////////
        function fillBrandsByCompany(company_id) {
            Brand.query({order:'name',company_id: company_id},function(resp) {
                vm.brands = resp.data.items;
            });          	
        }

        function init() {
            


            if (vm.item.id > 0) {
                if (vm.item.actual_stage && vm.item.actual_stage.name === 'Finalizado') {
                    vm.canEdit = false;    
                }
                if (!authSrv.hasPermission('editarProyectos') && !iAmInProject()) {
                    $state.go('app.my-projects');
                }
            } else {
                if (!authSrv.hasPermission('crearProyectos')) {
                    $state.go('app.my-projects');
                }
            }



            if (authSrv.getUser().area.name.toLowerCase() === 'administración') {
                vm.canFinish = true;
            }

           InfoSrv.getProjectStates().then(function(data) {
                vm.states = data;
                if (!vm.item.id) {
                    vm.item.state_id = 10;
                }
            });

            ProjectStage.query({ order: 'order'}).$promise.then(function(resp) {
                for(var i in resp.data.items) {
                    if (resp.data.items[i].name.toLowerCase() !== 'finalizado') {
                        vm.stages.push(resp.data.items[i]);        
                    } else {
                        if (vm.canFinish){
                            vm.stages.push(resp.data.items[i]);        
                        }
                    }
                }
                //vm.stages = resp.data.items;
            });

            Company.query({order:'name'},function(resp) {
                vm.companies = resp.data.items;
            });

            processData();
        }

        function processData() {
            if (vm.item.start_date) {
                vm.item.start_date = moment(vm.item.start_date).toDate();    
            }
            if (vm.item.delivery_date) {
                vm.item.delivery_date = moment(vm.item.delivery_date).toDate();    
            }
            
            if (vm.item.id) {
                fillBrandsByCompany(vm.item.company_id);     
            } else {
                vm.item.users = [];
            }
        }

        function iAmInProject() {
            for(var i in vm.item.users) {
                if (vm.item.users[i].id === authSrv.getUser().id) {
                    return true;
                }
            }

            return false;
        }


        function addUser() {
            var add = true;
            
            for(var i in vm.item.users) {
                if (vm.item.users[i].id === vm.acUsers.selectedItem.id) {
                    add = false;
                    if (vm.item.users[i].oper === 'D') {
                        delete vm.item.users[i].oper;
                    }
                }
            }

            if (add) {
                var newUser = angular.copy(vm.acUsers.selectedItem);
                newUser.oper = 'C';
                vm.item.users.push(newUser);
            }

            vm.acUsers.selectedItem = null;
        }

        function addStage() {
            var add = true;
            
            if (!angular.isArray(vm.item.stages)) {
                vm.item.stages = [];                
            }


            for(var i in vm.item.stages) {
                if (vm.item.stages[i].id === vm.selectedStage.id) {
                    add = false;
                    if (vm.item.stages[i].oper === 'D') {
                        delete vm.item.stages[i].oper;
                    }
                    if (vm.item.stages[i].name === 'Finalizado') {
                        vm.canEdit = false;
                    }                

                }
            }

            if (add) {
                var newStage = angular.copy(vm.selectedStage);
                newStage.oper = 'C';
                if (newStage.name === 'Finalizado') {
                    vm.canEdit = false;
                }                
                vm.item.stages.push(newStage);
                delete vm.selectedStage;

            }


            vm.selectedStage = null;
        }

        function addPO() {
            var item = {
                project_id: vm.item.id
            };

            if (!angular.isArray(vm.item.purchase_orders)) {
                vm.item.purchase_orders = [];                
            }

            openPODialog(item).then(function(data) {
                if (data) {
                    vm.item.purchase_orders.push(data);   
                }
            });           
        }           

        function editPO(item) {
            openPODialog(item).then(function(data) {
                if (data) {
                    angular.merge(item,data);
                }
            });      
        } 

        function removePO(pos, item) {
            DialogSrv.delete().then(function () {
                PurchaseOrder.delete(item).$promise.then(function (resp) {
                    vm.item.purchase_orders.splice(pos,1);
                });                
            });            
        }

        function addEstimate() {
            var item = {
                project_id: vm.item.id
            };

            if (!angular.isArray(vm.item.estimates)) {
                vm.item.estimates = []; 
            }

            openEstimateDialog(item).then(function(data) {
                if (data) {
                    vm.item.estimates.push(data);
                    vm.item.estimates_total += (data.amount * data.currency_quote);
                }
            });           

        }           

        function editEstimate(item) {
            var old_amount = (item.amount * item.currency_quote);
            openEstimateDialog(item).then(function(data) {
                if (data) {
                    angular.merge(item,data);
                    vm.item.estimates_total-= old_amount;
                    vm.item.estimates_total +=  (data.amount * data.currency_quote); 
                }
            });      
        } 

        function removeEstimate(pos, item) {
            var old_amount = item.amount * item.currency_quote;
            DialogSrv.delete().then(function () {
                ProjectEstimate.delete(item).$promise.then(function (resp) {
                    vm.item.estimates.splice(pos,1);
                    vm.item.estimates_total-= old_amount;
                });                
            });            
        }

        function addCost(type) {
            var item = {
                project_id: vm.item.id,
                type: type,
                currency_quote: 1
            };

            openCostDialog(item).then(function(data) {
                if (data) {
                    vm.item.costs.push(data);
                    switch (data.type) {
                        case 'I':
                            vm.item.internal_costs += (data.amount * data.currency_quote);  
                            break;
                        case 'S': 
                            vm.item.supplier_costs += (data.amount * data.currency_quote);  
                            break;

                    }
                }
            });           
        }           

        function editCost(item) {
            var old_amount = (item.amount * item.currency_quote);
            openCostDialog(item).then(function(data) {
                if (data) {
                    angular.merge(item,data);

                    switch (data.type) {
                        case 'I':
                            vm.item.internal_costs-= old_amount;
                            vm.item.internal_costs +=  (data.amount * data.currency_quote);  
                            break;
                        case 'S': 
                            vm.item.supplier_costs-= old_amount;
                            vm.item.supplier_costs += (data.amount * data.currency_quote);  
                            break;

                    }          
                }      
            });      
        } 

        function removeCost(pos, item) {
            var old_amount = item.amount * item.currency_quote;
            DialogSrv.delete().then(function () {
                ProjectCost.delete(item).$promise.then(function (resp) {
                    vm.item.costs.splice(pos,1);
                    switch (item.type) {
                        case 'I':
                            vm.item.internal_costs -= old_amount;  
                            break;
                        case 'S': 
                            vm.item.supplier_costs -= old_amount;  
                            break;

                    }                      
                });                
            });            
        }



        function openPODialog(item) {
            return $mdDialog.show({
              controller: 'CUPurchaseOrdersController',
              controllerAs: 'vm',
              templateUrl: 'app/main/projects/dialogs/po/cu-purchase-order.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:false,
              fullscreen: true,
              locals: {
                item: item
              }              
            });              
        }
        
        function openEstimateDialog(item) {
            return $mdDialog.show({
              controller: 'CUProjectEstimatesController',
              controllerAs: 'vm',
              templateUrl: 'app/main/projects/dialogs/estimates/cu-estimates.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:false,
              fullscreen: true,
              locals: {
                item: item
              }              
            });              
        }
        
        function openCostDialog(item) {
            return $mdDialog.show({
              controller: 'CUProjectCostsController',
              controllerAs: 'vm',
              templateUrl: 'app/main/projects/dialogs/costs/cu-costs.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:false,
              fullscreen: true,
              locals: {
                item: item
              }              
            });              
        }

        function removeItem(item) {
            item.oper = 'D';
            if (item.name === 'Finalizado') {
                vm.canEdit = true;
            }
        }

        function filterItems(item) {
            return item.oper !== 'D';
        }

        function changeCompany() {
        	vm.brands = [];
        	vm.item.brand_id = null;
        	if (vm.item.company_id) {
        		fillBrandsByCompany(vm.item.company_id);
        	}
        }

        function back() {
            $state.go('app.projects');
        }

        function grossProfitability() {
            return vm.item.estimates_total - (vm.item.supplier_costs + vm.item.internal_costs);
        }

        function save()
        {
            vm.saving = true;
            if (vm.item.id) {
                vm.item.$update(function(data){
                    back();
                });
            } else {
                vm.item.$save(function(data){
                    //back();
                    
                    processData();
                }).finally(function() {
                    vm.saving = false;
                });
            }
        }      
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            //'app.quick-panel',

            'app.api',
            'app.auth',

            'app.dashboard',

            'app.admin',
            'app.suppliers',
            'app.users',
            'app.projects',
            'app.customers',
            'app.reports'

        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .directive('cuHeader', Directive);

    /** @ngInject */
    function Directive($log)
    {
        return {
            restrict   : 'E',
            scope: {
                vm: '='
            },
            templateUrl: 'app/main/directives/cu-header/cu-header.html',
            link       : function (scope){
                
                scope.showBack = typeof scope.vm.back === 'function';

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .directive('cuFooter', Directive);

    /** @ngInject */
    function Directive()
    {
        return {
            restrict   : 'E',
            templateUrl: 'app/main/directives/cu-footer/cu-footer.html',
            link       : function (scope)
            {
            	return true;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .directive('chooseFile', Directive);

    /** @ngInject */
    function Directive()
    {
        return {
          link: function (scope, elem, attrs) {
            var button = elem.find('button');
            var input = angular.element(elem[0].querySelector('input#fileInput'));
            button.bind('click', function() {
              input[0].click();
            });
            input.bind('change', function(e) {
              scope.$apply(function() {
                var files = e.target.files;
                if (files[0]) {
                  scope.fileName = files[0].name;
                } else {
                  scope.fileName = null;
                }
              });
            });
          }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                },
                data: {
                    auth: true
                },
            });
    }

    /** @ngInject */
    function run(msNavigationService) {
        msNavigationService.saveItem('dashboard', {
            title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.dashboard',
            weight   : 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .factory('Dashboard', service);

    /** @ngInject */
    function service($http,$q,API_URL)
    {

    	var FINAL_API_URL = API_URL + 'dashboard';
    	var service = {
    		stats: stats
    	};

    	return service;

    	function stats() {
    		var deferred = $q.defer();

    		$http.post(FINAL_API_URL).then(function(resp) {
    			deferred.resolve(resp.data);
    		}, function(error) {
    			deferred.reject(error);
    		});

    		return deferred.promise;
    	}
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.customers.companies')
        .controller('CompaniesController', Controller);

    /** @ngInject */
    function Controller($log, Company, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Empresas',
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: 'name',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.customers_companies.cu');
        }

        function edit(item) {
           $state.go('app.customers_companies.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Company.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Company.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Company.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.customers.brands')
        .controller('BrandsController', Controller);

    /** @ngInject */
    function Controller($log, Brand, Company, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Marcas',
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: 'name',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            companies: [],
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            Company.query({order:'name'},function(resp) {
                vm.companies = resp.data.items;
            });
            filterList();
        }

        function create() {
            $state.go('app.customers_brands.cu');
        }

        function edit(item) {
           $state.go('app.customers_brands.cu',{id: item.id});
        }        

        function refreshList(ctrl,id) {
            vm.list.query.page = 1;
            filterList();
            if (ctrl) {
                ctrl.toggleSidenav(id);
            }
        }

        function filterList() {
            vm.list.promise = Brand.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Brand.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Brand.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();			
(function ()
{
    'use strict';

    angular
        .module('app.auth.permissions')
        .controller('PermissionsController', Controller);

    /** @ngInject */
    function Controller($log, Permission, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Permisos',
            subtitle: 'Administración de permisos del sistema',
            list: {
                promise: null,
                query: {
                    order: 'name',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.auth_permissions.cu');
        }

        function edit(item) {
           $state.go('app.auth_permissions.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Permission.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Permission.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Permission.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.roles')
        .controller('RolesController', Controller);

    /** @ngInject */
    function Controller($log, Role, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Roles',
            subtitle: false,
            list: {
                promise: null,
                query: {
                    order: 'id',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.auth_roles.cu');
        }

        function edit(item) {
           $state.go('app.auth_roles.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Role.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Role.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Role.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();        
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            data: {
                auth: false
            }
        })
        .state('app.auth_forgot-password', {
            url      : '/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_forgot-password': {
                    templateUrl: 'app/main/auth/login/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            data: {
                auth: false
            }            
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($log, authSrv, $state)
    {
        var vm = this;
        // Data
        vm.credentials = {};
        // Methods
        vm.login = login;
        //////////

        function login() {
            authSrv.login(vm.credentials).then(function() {
                $state.go('app.dashboard');
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('ForgotPasswordController', Controller);

    /** @ngInject */
    function Controller($state,User)
    {
        var vm = this;
        // Data
        vm.form = {};
        // Methods
        vm.forgot = forgot;
        //////////

        function forgot() {
            User.forgotPassword(vm.form, function(data) {
                if (data.state === 'OK') {
                    $state.go('app.auth_login');
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin.areas')
        .controller('AreasController', Controller);

    /** @ngInject */
    function Controller($log, Area, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Áreas',
            subtitle: 'Adm. de áreas de la agencia',
            list: {
                promise: null,
                query: {
                    search: '',
                    order: 'id',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            filterList();
        }

        function create() {
            $state.go('app.admin_areas.cu');
        }

        function edit(item) {
           $state.go('app.admin_areas.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Area.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Area.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Area.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();        
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'angular.filter',
                'ngAnimate',
                'ngAria',
                'md.data.table',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'satellizer',
                'permission', 
                'permission.ui',
                'ngStorage',
                'app.core.auth',
                'checklist-model',
                'ngFileUpload'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('compareTo', Directive);

    /** @ngInject */
    function Directive()
    {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {
                 
                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };
     
                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', Controller);

    /** @ngInject */
    function Controller($log, User, Role, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Usuarios',
            subtitle: false,
            roles: [],
            list: {
                promise: null,
                query: {
                    order: 'id',
                    limit: 50,
                    page: 1,
                    roles: []
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            Role.query({order:'display_name'}, function(resp) {
                vm.roles = resp.data.items;
            });

            filterList();
        }

        function create() {
            $state.go('app.users.cu');
        }

        function edit(item) {
           $state.go('app.users.cu',{id: item.id});
        }        

        function refreshList(ctrl,id) {
            vm.list.query.page = 1;
            filterList();
            if (ctrl) {
                ctrl.toggleSidenav(id);
            }
        }

        function filterList() {
            var query = angular.copy(vm.list.query);
            query.roles = query.roles.join(',');            
            vm.list.promise = User.query(query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    User.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                User.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.suppliers')
        .controller('SuppliersController', Controller);

    /** @ngInject */
    function Controller($log, Supplier, Skill, DialogSrv, $state)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Proveedores',
            subtitle: false,
            skills: [],
            list: {
                promise: null,
                query: {
                    order: 'id',
                    limit: 50,
                    page: 1,
                    skills: []
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            Skill.query(function(resp){
                vm.skills = resp.data.items;
            });
            filterList();
        }

        function create() {
            $state.go('app.suppliers.cu');
        }

        function edit(item) {
           $state.go('app.suppliers.cu',{id: item.id});
        }        

        function refreshList(ctrl,id) {
            vm.list.query.page = 1;
            filterList();
            if (ctrl) {
                ctrl.toggleSidenav(id);
            }
        }

        function filterList() {
            var query = angular.copy(vm.list.query);
            query.skills = query.skills.join(',');
            vm.list.promise = Supplier.query(query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Supplier.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Supplier.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();			
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ProjectsByController', Controller);

    /** @ngInject */
    function Controller($log,authSrv,by,ReportSrv,DataListsSrv,InfoSrv)
    {
        var vm = this;
        angular.extend(vm,{
            title: '',
            subtitle: false,
            by: by,
            hasFilters: false,
            list: {
                promise: null,
                query: {
                    by: 'stages',
                    order: '-total',
                    limit: 50,
                    page: 1
                },
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList,
                exportXls: exportXls
            },
            filters: {
                states: [],
                users: []
            }
        });

        init();

        function init() {
            $log.debug(by);
            switch (vm.by) {
                case 'stages':
                    initForStages(); 
                    break;
                case 'states':
                    initForStates(); 
                    break;    
                case 'users':
                    initForUsers(); 
                    break;  
                /*case 'customers':
                    initForCustomers(); 
                    break;                                                         */
            };
            //filterList();
        }

        function initForStages() {
            vm.title = 'Reportes - Proyectos por etapas';
            //vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'stages';
            /*DataListsSrv.get({
                key: 'projects',
                select: ['id','name']
            }).then(function(data) {
                $log.debug(data);
                vm.filters.projects = data;
                vm.list.query.project_id = 0;
            });*/
            refreshList();
        }

        function initForStates() {
            vm.title = 'Reportes - Proyectos por estados';
            //vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'states';
            InfoSrv.getProjectStates().then(function(data) {
                vm.filters.states = data;
                refreshList();
            });            

        }
        
        function initForUsers() {
            vm.title = 'Reportes - Proyectos por usuarios';
            vm.hasFilters = true;
            //vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'users';
            DataListsSrv.get({
                key: 'users',
                select: ['id','first_name','last_name']
            }).then(function(data) {
                vm.filters.users = data;
                vm.list.query.user_id = 0;
            });
            refreshList();            
        }


        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = ReportSrv.getProjects(vm.list.query).then(function(resp) {
                
                if (resp.state === 'OK') {
                    vm.list.items = resp.data.data;
                    vm.list.totalItems = resp.data.total;
                }                
            });
        }

        function exportXls() {
            ReportSrv.exportXls('projects',vm.list.query);
        }

    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('HoursByController', Controller);

    /** @ngInject */
    function Controller($log,authSrv,by,ReportSrv,DataListsSrv)
    {
        var vm = this;
        angular.extend(vm,{
            title: '',
            subtitle: false,
            by: by,
            list: {
                promise: null,
                query: {
                    by: 'areas',
                    order: 'hours',
                    limit: 50,
                    page: 1
                },
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList,
                exportXls: exportXls
            },
            filters: {
                projects: [],
                customer: []
            }
        });

        init();

        function init() {
            $log.debug(by);
            switch (vm.by) {
                case 'areas':
                    initForAreas(); 
                    break;
                case 'users':
                    initForUsers(); 
                    break;    
                case 'projects':
                    initForProjects(); 
                    break;  
                case 'customers':
                    initForCustomers(); 
                    break;                                                         
            };
            //filterList();
        }

        function initForAreas() {
            vm.title = 'Reportes - Hs. destinadas por áreas';
            vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'areas';
            DataListsSrv.get({
                key: 'projects',
                select: ['id','name']
            }).then(function(data) {
                $log.debug(data);
                vm.filters.projects = data;
                vm.list.query.project_id = 0;
            });
        }

        function initForUsers() {
            vm.title = 'Reportes - Hs. destinadas por usuarios';
            vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'users';
            DataListsSrv.get({
                key: 'projects',
                select: ['id','name']
            }).then(function(data) {
                vm.filters.projects = data;
                vm.list.query.project_id = 0;
            });
        }
        
        function initForProjects() {
            vm.title = 'Reportes - Hs. por proyectos';
            vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'projects';
            DataListsSrv.get({
                key: 'projects',
                select: ['id','name']
            }).then(function(data) {
                vm.filters.projects = data;
                vm.list.query.project_id = 0;
            });
        }

        function initForCustomers() {
            vm.title = 'Reportes - Hs. por clientes';
            vm.subtitle = 'Determine un rango de fechas para obtener el reporte';
            vm.list.query.by = 'customers';
            DataListsSrv.get({
                key: 'customers'
            }).then(function(data) {
                vm.filters.customers = data;
                vm.list.query.customer = 0;
            });
        }

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = ReportSrv.getHours(vm.list.query).then(function(resp) {
                $log.debug(resp);
                if (resp.state === 'OK') {
                    vm.list.items = resp.data.data;
                    vm.list.totalItems = resp.data.total;
                }                
            });
        }

        function exportXls() {
            ReportSrv.exportXls('hours',vm.list.query);
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('ProjectsController', Controller);

    /** @ngInject */
    function Controller($log, Project, DialogSrv, $state, InfoSrv, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Proyectos',
            subtitle: false,
            projectStates: [],
            list: {
                promise: null,
                query: {
                    order: '-id',
                    limit: 50,
                    page: 1
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            create: create,
            edit: edit,
            delete: deleteItem,
            deleteSelected: deleteSelected 
        });

        init();

        function init() {
            if (!authSrv.hasPermission('listarProyectos')) {
                $state.go('app.my-projects');
            } else {
                InfoSrv.getProjectStates().then(function(data) {
                    vm.projectStates = data;
                });
                filterList();

            }           
        }

        function create() {
            $state.go('app.projects.cu');
        }

        function edit(item) {
           $state.go('app.projects.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Project.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

        function deleteSelected() {
            if (vm.list.selected.length > 0) {
                DialogSrv.delete().then(function () {
                    Project.deleteSelected({items: vm.list.selected}).$promise.then(function(resp) {
                        filterList();
                    });
                });
            }
        }

        function deleteItem(item) {
            DialogSrv.delete().then(function () {
                Project.delete(item).$promise.then(function (resp) {
                    vm.list.filter();
                });                
            });
        }
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.projects')
        .controller('MyProjectsController', Controller);

    /** @ngInject */
    function Controller($log, Project, DialogSrv, $state, InfoSrv, authSrv)
    {
        var vm = this;
        angular.extend(vm,{
            title: 'Proyectos',
            subtitle: false,
            projectStates: [],
            list: {
                promise: null,
                query: {
                    order: '-id',
                    limit: 50,
                    page: 1,
                    user_id: authSrv.getUser().id
                },
                selected: [],
                items: [],
                totalItems: 0,
                filter: filterList,
                refresh: refreshList
            },
            
            //METHODS            
            edit: edit,
        });

        init();

        function init() {
            InfoSrv.getProjectStates().then(function(data) {
                vm.projectStates = data;
            });
            filterList();
        }


        function edit(item) {
           $state.go('app.projects.cu',{id: item.id});
        }        

        function refreshList() {
            vm.list.query.page = 1;
            filterList();
        }

        function filterList() {
            vm.list.promise = Project.query(vm.list.query,function($response) {
                if ($response.state === 'OK') {
                    vm.list.items = $response.data.items;
                    vm.list.totalItems = $response.data.totalItems;
                }
            }).$promise;
        }

    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', Controller);

    /** @ngInject */
    function Controller(Dashboard, $log)
    {
        var vm = this;

        // Data
        vm.title = 'Dashboard';
        

        // Methods
        vm.getStats = getStats;

        //////////
        init();

        function init() {
            getStats();
        }

        function getStats() {
            Dashboard.stats().then(function(data) {
                $log.debug(data);
                vm.stats = data;
            });
        }

    }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.api', []);
})();		
(function ()
{
    'use strict';

    angular
        .module('app.api')
        .factory('InfoSrv', service);

    /** @ngInject */
    function service($http, $q, API_URL,$localStorage,$log)
    {
    	var API_URL_FULL = API_URL + 'info/';
        var loaded = false;
        var service = {
        	all: all,
        	getProjectStates: getProjectStates,
        };

        return service;

        function all() {
            var deferred = $q.defer();

            if (!angular.isObject($localStorage.apiInfo)) {
                loaded = false;
                $localStorage.apiInfo = {};
            }
            if (loaded) {
                deferred.resolve($localStorage.apiInfo);
            } else {

                call(API_URL_FULL+'all','GET').then(function(data) {
                    
                    $localStorage.apiInfo = data;
                    $log.debug($localStorage.apiInfo);
                    loaded = true;
                    deferred.resolve(data);
                },function(err) {
                    deferred.reject(err);
                });
                
            }

            return deferred.promise;
        }



        function getProjectStates() {
            var deferred = $q.defer();

            /*if (!angular.isObject($localStorage.apiInfo) || !angular.isDefined($localStorage.apiInfo.projectStates)) {

                all().then(function(data) {
                    deferred.resolve(data.projectStates);
                },function(err) {
                    deferred.reject(err);
                });

            } else {
                deferred.resolve($localStorage.apiInfo.projectStates);
            }*/
            //while(!loaded);
            deferred.resolve($localStorage.apiInfo.project_states);
            return deferred.promise;
        }
        
		function call(path,method,data) {
			var deferred = $q.defer();

			$http({
				method: method,
				url: path,
				data: data || {}
			})
			.then(function (response) {
				if (response.status === 200) {
					deferred.resolve(response.data);
				}
			})
			.catch(function(err) {
				deferred.reject(err);
			});

			return deferred.promise;
		}
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.api')
        .factory('DataListsSrv', service);

    /** @ngInject */
    function service($http, $q, API_URL,$log)
    {
    	var API_URL_FULL = API_URL + 'data-lists';
        
        var service = {
        	get: _get
        };

        return service;

        function _get(params) {
            var deferred = $q.defer();

            call(API_URL_FULL,'POST',params).then(function(data) {
                deferred.resolve(data);
            },function(err) {
                deferred.reject(err);
            });
                
            return deferred.promise;
        }

        
		function call(path,method,data) {
			var deferred = $q.defer();

			$http({
				method: method,
				url: path,
				data: data || {}
			})
			.then(function (response) {
				if (response.status === 200) {
					deferred.resolve(response.data);
				}
			})
			.catch(function(err) {
				deferred.reject(err);
			});

			return deferred.promise;
		}
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        $mdThemingProvider.theme("success-toast");
        $mdThemingProvider.theme("error-toast");
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '500',
                    'hue-1'  : '700',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {   
                name: 'red',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : '700'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'toolbar': {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '500',
                    'hue-1'  : '700',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent  : {
                name: 'red',
                hues: {
                    'default': '500',
                    'hue-1'  : '700',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }                
            },
            warn: {
                name: 'deep-orange'
            },
            background: {
                name: 'grey'
            } 
        },
        'buttons': {
            primary   : {
                name: 'grey',
            },
            accent    : {
                name: 'indigo',
            },
            warn      : {
                name: 'red',
                hues: {
                    'default': '800',
                }
            },
            background: {
                name: 'grey',
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('ToastSrv', service);

    /** @ngInject */
    function service($mdToast)
    {
        var service = {
        	showError: showError,
            showMessage: showMessage 
        };

        return service;

        function showMessage(message,type) {
            type = type || 'error';
            var _container = '<md-toast md-theme="' + type + '-toast"><div class="md-toast-content">' + message + '</div></md-toast>';
            $mdToast.show({
                template: _container,
                position: 'top right',
                hideDelay: 5000,
                autoWrap: false
            });
        }

        function showError(error) {
        	var message;

            switch(error.status) {
                case 400: 
                    message = 'Su token de sesión finalizó.';
                    break;
                case 401: 
                    message = 'No estás autorizado para realizar esta acción';
                    break;
                case 422:
                    for(var prop in error.data){
                        message = error.data[prop][0];
                        break;
                    }                    
                    break;
                case 500:
                    message = error.data.error;
                    break;
                default:
                    message = error.data.error;
                    break;
            }

            var _container = '<md-toast md-theme="error-toast"><div class="md-toast-content">' + message + '</div></md-toast>';
        	$mdToast.show({
        		template: _container,
        		position: 'top right',
        		hideDelay: 5000,
        		autoWrap: false
        	});
        }

    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('DialogSrv', service);

    /** @ngInject */
    function service($mdDialog)
    {
        var service = {
        	delete: showDelete
        };

        function showDelete(title,text) {
        	title = title || 'Eliminar registro?';
        	text = text || 'Los datos eliminados no podrán ser recuperados';

            var confirm = $mdDialog.confirm()
                .title(title)
                .content(text)
                .ariaLabel('Eliminar')
                .ok('Eliminar')
                .cancel('Cancelar')
                .targetEvent(event);

            return $mdDialog.show(confirm);
        }

        return service;
    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('formatDate', formatDate);

    /** @ngInject */
    function formatDate()
    {
        return function (input,format)
        {
            var _format = format || 'DD/MM/YYYY';
            return moment(input).format(_format);
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('camelize', filter);

    /** @ngInject */
    function filter()
    {
        return function (value)
        {
            return (angular.isDefined(value) ? value.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
                if (p2) return p2.toUpperCase();
                return p1.toLowerCase();        
            }) : value);      
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.core.auth', []);
})();		
(function ()
{
    'use strict';

    angular
        .module('app.core.auth')
        .factory('auth2Srv', service);

    /** @ngInject */
    function service($q, $log, api, $auth, $state, $localStorage, $translate,PermPermissionStore)
    {
        var _loggedUser = null;
        var service = {
            login: login,
            isAuthenticated: isAuthenticated,
            logout: logout,
            getUser: getUser
        };

        return service;

        function login(credentials) {
            var deferred = $q.defer();
            $auth.login(credentials).then(function(response) {
                //_loggedUser = response.data.user;
                $log.debug(response.data.user);
                $localStorage.loggedUser = response.data.user;
                _definePermissions(response.data.user.roles);
                deferred.resolve();
            },function(response) {
                if (response.data && response.data.error){
                    deferred.reject($translate.instant('LOGIN.ERRORS.' + response.data.error));    
                }else{
                    deferred.reject('GENERAL_ERROR');    
                }
            });

            return deferred.promise;
        }

        function isAuthenticated() {
            return $auth.isAuthenticated();
        }

        function getUser() {
            return (isAuthenticated ? $localStorage.loggedUser : false);
        }

        function logout() {
            $auth.logout();
            PermPermissionStore.clearStore();
            delete $localStorage.loggedUser;
            $state.go('app.auth_login');
            return true;
        }

        function _definePermissions(roles){
            var _permissions = [];
            for(var i in roles) {
                for(var j in roles[i].permissions){
                    if( angular.isUndefined(_permissions[roles[i].permissions[j].name]) ){
                        _permissions.push(roles[i].permissions[j].name);
                    }
                }
            }
            PermPermissionStore.defineManyPermissions(_permissions, function (permissionName) {
              return _permissions.indexOf(permissionName) > -1;
            });
        }

    }

})();		
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $log, $urlRouter, authSrv)
    {
        
        //$urlRouter.sync();
        // Also enable router to listen to url changes
        //$urlRouter.listen();

        $rootScope.$on('$stateChangeStart',
          function (event, toState) {
            if (toState.data && toState.data.auth && !authSrv.isAuthenticated()) {
              event.preventDefault();
              $state.go('app.auth_login');
            }
            if (toState.name === 'app.auth_login' && authSrv.isAuthenticated()) {
              event.preventDefault();
              $state.go('app.dashboard');                
            }
        });        
    	
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core.auth')
        .config(config);

    /** @ngInject */
    function config($urlRouterProvider, authSrvProvider)
    {
        authSrvProvider.init();
        //console.debug(authConfigProvider);
    	//$urlRouterProvider.deferIntercept();
    }
})();		
(function ()
{
    'use strict';

    angular
        .module('app.core.auth')
        .provider('authSrv', authSrvProvider);

    /** @ngInject */
    function authSrvProvider($authProvider, $localStorageProvider, $httpProvider)
    {
        // Default configuration
        var _loggedUser = null;
        var _permissions = null;
        var _roles = null; 
        var _onAuth = [];

        var loginPath = 'app.auth_login';

        $authProvider.loginUrl = '/auth/login';



        // Methods
        this.setLoginUrl = setLoginUrl;
        this.setPrefix = setPrefix;
        this.init       = init;
        //////////

        function setLoginUrl(url) {
            $authProvider.loginUrl = url;
        }

        function setPrefix(prefix) {
            
            $authProvider.tokenPrefix = prefix;
            $localStorageProvider.setKeyPrefix(prefix + '-');
            //$localStorageProvider.setKeyPrefix(prefix + '_');
        }

        function init() {

            $httpProvider.interceptors.push(['$location', '$q', '$injector', function($location, $q, $injector) {
                return {
                    responseError: function (response) {
                        if (response.config && response.config.url && response.config.url.indexOf('/api/') > -1) {
                            $injector.get('ToastSrv').showError(response);
                            if (response.status === 400) {
                                $injector.get('authSrv').logout();
                            } else if(response.status === 401) {
                                //$injector.get('$state').transitionTo('app.dashboard');
                            }
                                
                        }

                        return $q.reject(response);
                    }
                };
            }]);
        };



        /**
         * Service
         */
        this.$get = function ($q, $log, $auth, $state, $localStorage, $translate,PermPermissionStore,PermRoleStore)
        {
            var service = {
                init: init,
                login: login,
                onAuth: onAuth,
                isAuthenticated: isAuthenticated,
                logout: logout,
                getUser: getUser,
                updateUser: updateUser,
                hasRole: hasRole,
                setPermissions: setPermissions,
                hasPermission: hasPermission,
                hasAnyPermission: hasAnyPermission              
            };

            return service;

            //////////
            function init() {
                
                if (isAuthenticated()){
                    _definePermissions(getUser().role);
                    runOnAuth();
                }
            }

            function onAuth(fn) {
                _onAuth.push(fn);
            }

            function runOnAuth() {
                angular.forEach(_onAuth, function(fn){
                    fn();
                });                
            }

            function login(credentials) {
                var deferred = $q.defer();

                $auth.login(credentials).then(function(response) {
                    $localStorage.loggedUser = response.data.user;
                    _definePermissions(response.data.user.role);
                    runOnAuth();                    
                    deferred.resolve();
                },function(response) {
                    if (response.data && response.data.error){
                        $log.debug($translate.instant('LOGIN.ERRORS.' + response.data.error));
                        deferred.reject($translate.instant('LOGIN.ERRORS.' + response.data.error));    
                    }else{
                        deferred.reject('general_error');    
                    }
                });

                return deferred.promise;
            }

            function isAuthenticated() {
                return $auth.isAuthenticated();
            }

            function getUser() {
                return (isAuthenticated ? $localStorage.loggedUser : false);
            }

            function updateUser(user) {
                delete user.role;
                delete user.roles;
                angular.extend($localStorage.loggedUser,user);
            }

            function hasRole(role) {
                return ($localStorage.loggedUser.role.id === role.id);
            }

            function hasPermission(permissionName) {
                return PermPermissionStore.getPermissionDefinition(permissionName);
            }

            function hasAnyPermission(permissions) {
                var permStore = PermPermissionStore.getStore();
                for(var i in permissions) {
                    if (angular.isDefined(permStore[permissions[i]])) {
                        return true;
                    }
                }
                return false;
            }
            
            function logout() {
                $auth.logout();
                PermPermissionStore.clearStore();
                delete $localStorage.loggedUser;
                $state.go(loginPath);
                return true;
            }

            function setPermissions(role,clear) {
                $localStorage.loggedUser.roles[0] = role;
                $localStorage.loggedUser.role = role;
                _definePermissions(role,clear);
            }

            function _definePermissions(role,clear){
                var _permissions = [],
                    _rolePermissions = [];

                if (clear) {
                    PermRoleStore.clearStore();
                    PermPermissionStore.clearStore();
                }     

                for(var j in role.permissions){
                    _rolePermissions.push(role.permissions[j].name);
                    if( angular.isUndefined(_permissions[role.permissions[j].name]) ){
                        _permissions.push(role.permissions[j].name);
                    }
                }
                PermRoleStore.defineRole(role.name,_rolePermissions);
                PermPermissionStore.defineManyPermissions(_permissions, function (permissionName) {
                  return _permissions.indexOf(permissionName) > -1;
                });

            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        //$translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $document)
    {
        var vm = this;

        // Data
        //vm.currentUser = authSrv.getUser();

        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        //vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        //vm.openChangePasswordDialog = openChangePasswordDialog; 

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            //vm.selectedLanguage = vm.languages['es'];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,authSrv, $mdDialog, User, $state,$document)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.currentUser = authSrv.getUser();

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.logout = logout;
        vm.openChangePasswordDialog = openChangePasswordDialog; 

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            authSrv.logout();
            $state.go('app.auth_login');
        }

        function openChangePasswordDialog() {
            $mdDialog.show({
                controller         : 'CPUsersController',
                controllerAs       : 'vm',
                locals             : {
                    Item: new User(vm.currentUser) 
                },
                templateUrl        : 'app/main/users/dialogs/cp/cp-users.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true
            });            
        }                

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state,InfoSrv, authSrv)
    {
        authSrv.onAuth(function() {
            InfoSrv.all();
        });
        authSrv.init();
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            stateChangeErrorEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise( function($injector) {
          var $state = $injector.get("$state");
          $state.go('app.auth_login');
        });

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                },
                data: {
                    auth: true,
                    permissions: {
                        redirectTo: 'app.dashboard'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming,$mdSidenav)
    {
        var vm = this;
        
        // Data
        vm.themes = fuseTheming.themes;
        vm.toggleSidenav = toggleSidenav;
        //////////

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('API_URL', 'api/public/api/');
        //.constant('API_URL', 'http://angularavel.api/api/');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider,$translatePartialLoaderProvider,$localStorageProvider,authSrvProvider,API_URL, $mdDateLocaleProvider)
    {
        authSrvProvider.setLoginUrl(API_URL + 'authenticate');
        authSrvProvider.setPrefix('idAdmin');

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translatePartialLoaderProvider.addPart('app');

        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'DD/MM/YYYY', true);
          return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = function(date) {
          var m = moment(date);
          return date && m.isValid() ? m.format('DD/MM/YYYY') : '';
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.customers', [
        	'app.customers.companies',
            'app.customers.brands'
    	])
        .run(run);
	    
	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        msNavigationService.saveItem('customers', {
	            title    : 'Clientes',
	            icon     : 'icon-factory',
	            weight   : 2,
                hidden: function ()
                {
                    return !authSrv.hasAnyPermission(['listarEmpresasClientes','listarMarcasClientes']);
                }                  
	        });  
	    }	           
})();		
(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login',
            'app.auth.roles',
            'app.auth.permissions'
        ]);
 
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('app.admin', [
        	'app.admin.areas'/*,
        	'app.admin.skills'*/
    	])
        .run(run);

	    /** @ngInject */
	    function run(msNavigationService, authSrv)
	    {
	        // Navigation
	        msNavigationService.saveItem('admin', {
	            title    : 'Administración',
                icon     : 'icon-hexagon-outline', 
	            weight   : 2,
                hidden: function ()
                {
                    return !authSrv.hasAnyPermission(['listarUsuarios','listarRoles','listarPermisos','listarAreas']);
                }                
	        }); 	    	
	    }        
})();		
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-background-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-accent\" md-theme=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"page-layout carded fullwidth\" layout=\"column\"><cu-header vm=\"vm\"></cu-header><div class=\"scrollable\" \nms-scroll flex><div layout=\"column\" layout-margin><span class=\"md-title\" layout=\"row\" layout-align=\"start center\" \nng-repeat-start=\"group in vm.stats\"><md-icon md-font-icon=\"{{ group.icon }}\" class=\"s24 hint-text\"></md-icon><span \nflex>{{ group.title }}</span></span><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-repeat-end>\n<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" ng-repeat=\"item in group.items\">\n<ms-widget-front class=\"{{ item.color }}-400-bg white-fg\" layout=\"row\" flex><div class=\"pv-8 ph-16\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 pb-8\">{{ item.count }}</span> <span class=\"font-weight-500 secondary-text text-uppercase\">\n{{ item.title }}</span></div><div><md-icon md-font-icon=\"{{ item.icon }}\" class=\"s48 hint-text\"></md-icon></div></div>\n</ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/projects/my-projects.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Proyectos\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div></div><div \nclass=\"scrollable\" ms-scroll flex><md-table-container><table md-table class=\"md-table-list\" \nng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\"><thead md-head md-order=\"vm.list.query.order\" \nmd-on-reorder=\"vm.list.filter\" class=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" \nmd-order-by=\"id\">ID</th><th md-column md-order-by=\"name\">Nombre</th><th md-column>Cliente</th><th md-column \nmd-order-by=\"state_id\">Estado</th><th md-column class=\"c-actions\"></th></tr></thead><tbody md-body \nclass=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell \nclass=\"c-id\">{{item.id}}</td><td md-cell>{{item.name}}</td><td md-cell>\n{{(item.brand_id > 0 ? item.brand.name + \' (\' + item.company.name + \')\': item.company.name)}}</td><td md-cell>\n{{vm.projectStates[item.state_id]}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\">\n<md-button md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.edit(item)\">\n<md-tooltip md-direction=\"top\">Editar/Ver</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button>\n</div></td></tr></tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/projects/projects.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Proyectos\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearProyectos\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarProyectos\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">Nombre</th><th md-column>Cliente</th><th md-column md-order-by=\"state_id\">Estado</th><th md-column \nclass=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" \nmd-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>{{item.name}}\n</td><td md-cell>{{(item.brand_id > 0 ? item.brand.name + \' (\' + item.company.name + \')\': item.company.name)}}</td><td \nmd-cell>{{vm.projectStates[item.state_id]}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button permission permission-only=\"\'editarProyectos\'\" md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button permission \npermission-only=\"\'eliminarProyectos\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \naria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></div>\n<md-table-pagination class=\"md-background-bg md-hue-2\" layout-align=\"space-between center\" \nmd-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" md-page=\"vm.list.query.page\" \nmd-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/reports/hours-by.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Proyectos\"><cu-header vm=\"vm\"></cu-header><form \nname=\"frm\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div class=\"\" flex=\"90\" layout=\"row\" \nlayout-align=\"start\" layout-wrap layout-padding><md-input-container flex=\"50\" flex-gt-xs=\"30\"><label>Desde</label>\n<md-datepicker ng-model=\"vm.list.query.from_date\" name=\"from_date\" required></md-datepicker><div \nng-messages=\"frm.from_date.$error\" role=\"alert\"><span ng-message=\"required\">El campo es obligatorio</span> <span \nng-message=\"valid\">Fecha incorrecta</span></div></md-input-container><md-input-container md-no-asterisk flex=\"50\" \nflex-gt-xs=\"30\"><md-datepicker ng-model=\"vm.list.query.to_date\" name=\"to_date\" placeholder=\"Hasta\" required>\n</md-datepicker><div ng-messages=\"frm.to_date.$error\" role=\"alert\"><span ng-message=\"required\">El campo es obligatorio\n</span> <span ng-message=\"valid\">Fecha incorrecta</span></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"30\" ng-if=\"vm.by !== \'customers\'\"><label>Proyecto</label><md-select name=\"project\" \nng-model=\"vm.list.query.project_id\"><md-option ng-value=\"0\">Todos</md-option><md-option \nng-repeat=\"option in vm.filters.projects\" ng-value=\"option.id\">{{option.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" ng-if=\"vm.by === \'customers\'\"><label>Cliente\n</label><md-select name=\"customer\" ng-model=\"vm.list.query.customer\"><md-option ng-value=\"0\">Todos</md-option>\n<md-option ng-repeat=\"option in vm.filters.customers\" ng-value=\"option\">{{option.name}}</md-option></md-select>\n</md-input-container></div><div flex></div><md-button md-theme=\"buttons\" ng-disabled=\"frm.$invalid\" class=\"md-raised\" \naria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\">Filtrar</md-button><md-button md-theme=\"buttons\" \nng-disabled=\"frm.$invalid\" class=\"md-raised\" aria-label=\"Exportar\" ng-click=\"vm.list.exportXls()\">Exportar</md-button>\n</form><div class=\"scrollable\" ms-scroll flex><md-table-container><table md-table class=\"md-table-list\" \nmd-progress=\"vm.list.promise\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column ng-if=\"vm.by === \'areas\'\">Area</th><th md-column \nng-if=\"vm.by === \'users\'\">Usuario</th><th md-column ng-if=\"vm.by === \'projects\'\">Proyecto</th><th md-column \nng-if=\"vm.by === \'customers\'\">Cliente</th><th md-column>Hs</th></tr></thead><tbody md-body class=\"md-background-bg\"><tr\n md-row ng-repeat=\"item in vm.list.items\"><td md-cell ng-if=\"vm.by === \'areas\'\">{{ item.name }}</td><td md-cell \nng-if=\"vm.by === \'users\'\">{{ item.first_name }} {{ item.last_name }}</td><td md-cell ng-if=\"vm.by === \'projects\'\">\n{{ item.name }}</td><td md-cell ng-if=\"vm.by === \'customers\'\">\n{{ item.company_name }}{{ (item.brand_id ? \' - \' + item.brand_name : \'\') }}</td><td md-cell>{{ item.hours }}</td></tr>\n</tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/reports/projects-by.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Proyectos\"><cu-header vm=\"vm\"></cu-header><form \nname=\"frm\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\" ng-if=\"vm.hasFilters\"><div class=\"\" \nflex=\"90\" layout=\"row\" layout-align=\"start\" layout-wrap layout-padding><md-input-container flex=\"100\" flex-gt-xs=\"30\" \nng-if=\"vm.by === \'users\'\"><label>Usuarios</label><md-select name=\"users\" ng-model=\"vm.list.query.user_id\"><md-option \nng-value=\"0\">Todos</md-option><md-option ng-repeat=\"option in vm.filters.users\" ng-value=\"option.id\">\n{{option.last_name}} {{option.first_name}}</md-option></md-select></md-input-container></div><div flex></div><md-button\n md-theme=\"buttons\" ng-disabled=\"frm.$invalid\" class=\"md-raised\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\">\nFiltrar</md-button><md-button md-theme=\"buttons\" ng-disabled=\"frm.$invalid\" class=\"md-raised\" aria-label=\"Exportar\" \nng-click=\"vm.list.exportXls()\">Exportar</md-button></form><div class=\"scrollable\" ms-scroll flex><md-table-container>\n<table md-table class=\"md-table-list\" md-progress=\"vm.list.promise\"><thead md-head md-order=\"vm.list.query.order\" \nmd-on-reorder=\"vm.list.filter\" class=\"md-background-bg md-hue-2\"><tr md-row><th md-column ng-if=\"vm.by === \'stages\'\">\nEtapa</th><th md-column ng-if=\"vm.by === \'states\'\">Estado</th><th md-column ng-if=\"vm.by === \'users\'\">Usuario</th><th \nmd-column ng-if=\"vm.by === \'users\'\">Area</th><th md-column>Total</th></tr></thead><tbody md-body \nclass=\"md-background-bg\"><tr md-row ng-repeat=\"item in vm.list.items\"><td md-cell ng-if=\"vm.by === \'stages\'\">\n{{ item.name }}</td><td md-cell ng-if=\"vm.by === \'states\'\">{{ vm.filters.states[item.state_id] }}</td><td md-cell \nng-if=\"vm.by === \'users\'\">{{ item.first_name }} {{ item.last_name }}</td><td md-cell ng-if=\"vm.by === \'users\'\">\n{{ item.name }}</td><td md-cell>{{ item.total }}</td></tr></tbody></table></md-table-container></div>\n<md-table-pagination class=\"md-background-bg md-hue-2\" layout-align=\"space-between center\" \nmd-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" md-page=\"vm.list.query.page\" \nmd-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/suppliers/suppliers.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Proveedores\"><cu-header vm=\"vm\"></cu-header><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button md-theme=\"buttons\" class=\"md-icon-button action-button\" \naria-label=\"Filtrar\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\"><md-tooltip md-direction=\"top\">Filtrar</md-tooltip>\n<md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearProveedores\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarProveedores\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><md-sidenav class=\"sidenav main-sidenav\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/suppliers/sidenavs/filters.html\'\"></md-sidenav><div class=\"scrollable\" ms-scroll flex><md-sidenav\n class=\"sidenav main-sidenav\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/suppliers/sidenavs/filters.html\'\"></md-sidenav><md-table-container><table md-table \nclass=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" md-row-select multiple=\"multiple\">\n<thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" class=\"md-background-bg md-hue-2\"><tr \nmd-row><th md-column md-order-by=\"business_name\">Razón social</th><th md-column md-order-by=\"contact_name\">Contacto\n</th><th md-column md-order-by=\"contact_email\">Email</th><th md-column class=\"c-actions\"></th></tr></thead><tbody \nmd-body class=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td \nmd-cell>{{item.business_name}}</td><td md-cell>{{item.contact_name}}</td><td md-cell>{{item.contact_email}}</td><td \nmd-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button permission \npermission-only=\"\'editarProveedores\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" \nng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\">\n</md-icon></md-button><md-button permission permission-only=\"\'eliminarProveedores\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr>\n</tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/users/users.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Users\"><cu-header vm=\"vm\"></cu-header><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-theme=\"buttons\" class=\"md-icon-button action-button\" \naria-label=\"Filtrar\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\"><md-tooltip md-direction=\"top\">Filtrar</md-tooltip>\n<md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearUsuarios\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarUsuarios\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><md-sidenav class=\"sidenav main-sidenav\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/users/sidenavs/filters.html\'\"></md-sidenav><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\"><tr \nmd-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column md-order-by=\"first_name\">NOMBRE</th><th \nmd-column md-order-by=\"last_name\">APELLIDO</th><th md-column md-order-by=\"email\">ROL</th><th md-column>AREA</th><th \nmd-column class=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" \nmd-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>\n{{ item.first_name }}</td><td md-cell>{{ item.last_name }}</td><td md-cell>{{ item.roles[0].display_name }}</td><td \nmd-cell>{{ item.area.name }}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button \npermission permission-only=\"\'editarUsuarios\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" \naria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarUsuarios\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\">\n<md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</td></tr></tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin/areas/areas.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Areas\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearAreas\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" aria-label=\"Nuevo\" \nng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button permission permission-only=\"\'eliminarAreas\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">NOMBRE</th><th md-column md-order-by=\"user_id\">RESPONSABLE</th><th md-column class=\"c-actions\"></th>\n</tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" \nng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>{{item.name}}</td><td md-cell>\n{{item.responsible.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button \npermission permission-only=\"\'editarAreas\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" \nng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\">\n</md-icon></md-button><md-button permission permission-only=\"\'eliminarAreas\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr>\n</tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/auth/login/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"assets/images/logo.png\"></div><div class=\"title\">Recupere su password</div><form \nname=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"\">El campo es requerido</span></div><div ng-message=\"pattern\"><span>El formato del email es incorrecto\n</span></div></div></md-input-container><md-button ng-click=\"vm.forgot()\" type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Recuperar\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\">Recuperar</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.auth_login\">Volver a login</a>\n</div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"assets/images/logo.png\"></div><div class=\"title\">Acceso al sistema</div><form name=\"loginForm\" novalidate \nng-submit=\"vm.login()\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.credentials.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEl email es requerido</span></div><div ng-message=\"pattern\"><span>El formato del email es incorrecto</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.credentials.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>El Password es requerido</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div flex></div><a\n ui-sref=\"app.auth_forgot-password\" class=\"forgot-password md-accent-color\">Recuperar password</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"INGRESAR\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">INGRESAR</md-button></form></div></div></div>");
$templateCache.put("app/main/auth/permissions/permissions.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"permissions\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearPermisos\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarPermisos\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\"><tr \nmd-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column md-order-by=\"display_name\">PERMISO</th><th \nmd-column md-order-by=\"name\" permission permission-only=\"\'editarPermisos\'\">Key</th><th md-column class=\"c-actions\">\n</th></tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" \nng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>{{item.display_name}}</td><td \nmd-cell>{{item.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button \npermission permission-only=\"\'editarPermisos\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" \naria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button \npermission permission-only=\"\'eliminarPermisos\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \naria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td>\n</tr></tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/auth/roles/roles.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Roles\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearRoles\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" aria-label=\"Nuevo\" \nng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button permission permission-only=\"\'eliminarRoles\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\"><tr \nmd-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column md-order-by=\"display_name\">Rol</th><th \nmd-column md-order-by=\"name\" permission permission-only=\"\'editarRoles\'\">Key</th><th md-column class=\"c-actions\"></th>\n</tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" \nng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>{{item.display_name}}</td><td \nmd-cell permission permission-only=\"\'editarRoles\'\">{{item.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button permission permission-only=\"\'editarRoles\'\" md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button permission \npermission-only=\"\'eliminarRoles\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" \nng-click=\"vm.delete(item)\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></div></td></tr></tbody></table></md-table-container></div><md-table-pagination \nclass=\"md-background-bg md-hue-2\" layout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" \nmd-label=\"{page: \'Pág:\'}\" md-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" \nmd-on-paginate=\"vm.list.filter\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/customers/brands/brands.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"MarcasClientes\"><cu-header vm=\"vm\"></cu-header><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"\"><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\"><md-tooltip \nmd-direction=\"top\">Filtrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div>\n<md-button permission permission-only=\"\'crearMarcasClientes\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-primary action-button\" aria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip \nmd-direction=\"top\">Nuevo</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission \npermission-only=\"\'eliminarMarcasClientes\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \nng-disabled=\"vm.list.selected.length === 0\" aria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip \nmd-direction=\"top\">Eliminar selección</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n<md-sidenav class=\"sidenav main-sidenav\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/customers/brands/sidenav/filters.html\'\"></md-sidenav><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">Nombre</th><th md-column>Empresa</th><th md-column>Contacto</th><th md-column>Responsable</th><th \nmd-column class=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" \nmd-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}</td><td md-cell>{{item.name}}\n</td><td md-cell>{{item.company.name}}</td><td md-cell>{{item.contact_name}}</td><td md-cell>{{item.responsible.name}}\n</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button permission \npermission-only=\"\'editarMarcasClientes\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" \nng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\">\n</md-icon></md-button><md-button permission permission-only=\"\'eliminarMarcasClientes\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr>\n</tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/customers/companies/companies.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"EmpresasClientes\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearEmpresasClientes\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarEmpresasClientes\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">Nombre</th><th md-column class=\"c-actions\"></th></tr></thead><tbody md-body \nclass=\"md-background-bg\"><tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell \nclass=\"c-id\">{{item.id}}</td><td md-cell>{{item.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button permission permission-only=\"\'editarEmpresasClientes\'\" md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button permission \npermission-only=\"\'eliminarEmpresasClientes\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \naria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></div>\n<md-table-pagination class=\"md-background-bg md-hue-2\" layout-align=\"space-between center\" \nmd-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" md-page=\"vm.list.query.page\" \nmd-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/directives/cu-footer/cu-footer.html","<div class=\"toolbar-footer md-background-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.back()\" md-theme=\"buttons\" class=\"md-raised\" aria-label=\"Cancelar\"><span>CANCELAR</span></md-button><span \nflex></span><md-button ng-click=\"vm.save()\" md-theme=\"buttons\" class=\"md-raised md-accent\" ng-disabled=\"frm.$invalid\" \naria-label=\"Guardar\"><span>GUARDAR</span></md-button></div>");
$templateCache.put("app/main/directives/cu-header/cu-header.html","<div layout=\"row\" layout-align=\"space-between center\" layout-padding class=\"md-accent-bg md-whiteframe-1dp\"><md-button \nng-if=\"showBack\" class=\"md-icon-button no-margin no-padding\" ng-click=\"vm.back()\" aria-label=\"Volver\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button><div layout=\"column\"><span class=\"md-title\">\n{{ vm.title }}</span><h6 class=\"no-margin\" ng-if=\"vm.subtitle\">{{ vm.subtitle }}</h6></div><span flex></span></div>");
$templateCache.put("app/main/projects/cu/cu-projects.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-projects\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-padding class=\"md-accent-bg\"><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vm.back()\" aria-label=\"Volver\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button><div layout=\"column\"><span class=\"md-title\">\n{{ vm.title }}</span><h6 class=\"no-margin\" ng-if=\"vm.subtitle\">{{vm.subtitle}}</h6></div><span flex></span></div><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"GENERAL\" md-on-select=\"vm.showSaveButton = true\" \nmd-on-deselect=\"vm.showSaveButton = false\"><md-card><md-card-content layout=\"row\" layout-align=\"start start\" \nlayout-wrap layout-padding><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"name\" ng-model=\"vm.item.name\" \nplaceholder=\"Nombre\" md-maxlength=\"100\" required ng-disabled=\"!vm.canEdit\"><div ng-messages=\"frm.name.$error\" \nng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">\nEl campo es obligatorio</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nEstado</label><md-select name=\"state_id\" ng-model=\"vm.item.state_id\" ng-disabled=\"!vm.canEdit\"><md-option \nng-repeat=\"(id,name) in vm.states\" ng-value=\"id\" ng-selected=\"{{ vm.item.state_id == id }}\">{{name}}</md-option>\n</md-select></md-input-container></md-card-content></md-card><md-card ng-if=\"vm.item.id > 0\"><md-card-content \nlayout=\"row\" layout-align=\"start start\" layout-wrap layout-padding><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input name=\"name\" ng-model=\"vm.item.work_orders[0].number\" placeholder=\"Orden de trabajo\" ng-disabled=\"true\">\n</md-input-container></md-card-content></md-card><md-card><md-card-header class=\"p-10\"><md-card-header-text><span \nclass=\"h4\">Cliente</span></md-card-header-text></md-card-header><md-divider></md-divider><md-card-content layout=\"row\" \nlayout-wrap layout-padding><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"mb-10\"><label>Empresa</label>\n<md-select name=\"company_id\" ng-model=\"vm.item.company_id\" ng-change=\"vm.changeCompany()\" required \nng-disabled=\"!vm.canEdit\"><md-option ng-value=\"0\">Seleccionar</md-option><md-option ng-repeat=\"option in vm.companies\" \nng-value=\"option.id\" ng-selected=\"{{ vm.item.company_id == option.id }}\">{{option.name}}</md-option></md-select><div \nng-messages=\"frm.company_id.$error\" ng-show=\"frm.company_id.$touched\" role=\"alert\" ng-disabled=\"!vm.canEdit\"><div \nng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" class=\"mb-10\"><label>Marca {{ vm.item.brand_id }}\n</label><md-select name=\"brand_id\" ng-model=\"vm.item.brand_id\" ng-disabled=\"!vm.canEdit\"><md-option ng-value=\"0\">\nSeleccionar</md-option><md-option ng-repeat=\"option in vm.brands\" ng-value=\"option.id\" \nng-selected=\"{{ vm.item.brand_id == option.id }}\">{{option.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"contact_name\" ng-model=\"vm.item.contact_name\" \nplaceholder=\"Contacto\" md-maxlength=\"100\" ng-disabled=\"!vm.canEdit\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"contact_email\" ng-model=\"vm.item.contact_email\" \nplaceholder=\"E-mail contacto\" md-maxlength=\"100\" ng-disabled=\"!vm.canEdit\"><div ng-messages=\"frm.contact_email.$error\" \nng-show=\"frm.contact_email.$touched\" role=\"alert\"><div ng-message=\"email\"><span>El formato del email es incorrecto\n</span></div></div></md-input-container></md-card-content></md-card><md-card><md-card-content layout=\"row\" \nlayout-align=\"start start\" layout-wrap layout-padding><md-input-container flex=\"50\" flex-gt-xs=\"25\" md-no-float \nmd-no-asterisk><div class=\"font-size-10 text-uppercase grey-500-fg\">Fecha de inicio</div><md-datepicker \nng-model=\"vm.item.start_date\" name=\"start_date\" placeholder=\"\" md-hide-icons=\"calendar\" required \nng-disabled=\"!vm.canEdit\"></md-datepicker><div ng-messages=\"frm.start_date.$error\" role=\"alert\"><span \nng-message=\"required\">El campo es obligatorio</span> <span ng-message=\"valid\">Fecha incorrecta</span></div>\n</md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"25\" md-no-float><div \nclass=\"font-size-10 text-uppercase grey-500-fg\">Fecha de entrega (Est)</div><md-datepicker \nng-model=\"vm.item.delivery_date\" name=\"delivery_date\" placeholder=\"\" md-hide-icons=\"calendar\" \nng-disabled=\"!vm.canEdit\"></md-datepicker><div ng-messages=\"frm.delivery_date.$error\" role=\"alert\"><span \nng-message=\"valid\">Fecha incorrecta</span></div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"25\" \nmd-no-float md-no-asterisk><div class=\"font-size-10 text-uppercase grey-500-fg\">HS. Estimadas</div><input \nname=\"estimated_hours\" ng-model=\"vm.item.estimated_hours\" placeholder=\"\" type=\"number\" required \nng-disabled=\"!vm.canEdit\"><div ng-messages=\"frm.estimated_hours.$error\" ng-show=\"frm.estimated_hours.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div>\n</div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"25\" md-no-float md-no-asterisk><div \nclass=\"font-size-10 text-uppercase grey-500-fg\">HS. Reales</div><input name=\"real_hours\" ng-disabled=\"true\" \nng-model=\"vm.item.total_hours\" placeholder=\" \" \nng-class=\"{\'red-500-fg\': vm.item.total_hours > vm.item.estimated_hours,\'green-500-fg\': vm.item.total_hours <= vm.item.estimated_hours}\" \nng-disabled=\"!vm.canEdit\"></md-input-container></md-card-content></md-card><ng-include \nsrc=\"\'app/main/projects/templates/inc-project-stages.html\'\"></ng-include><ng-include \nsrc=\"\'app/main/projects/templates/inc-project-users.html\'\"></ng-include></md-tab><md-tab label=\"ORDENES DE COMPRA\" \nng-disabled=\"!vm.item.id\"><ng-include src=\"\'app/main/projects/templates/inc-project-po.html\'\"></ng-include></md-tab>\n<md-tab label=\"PRESUPUESTOS\" ng-disabled=\"!vm.item.id\"><ng-include \nsrc=\"\'app/main/projects/templates/inc-project-estimates.html\'\"></ng-include></md-tab><md-tab label=\"COSTOS\" \nng-disabled=\"!vm.item.id\"><ng-include src=\"\'app/main/projects/templates/inc-project-s-costs.html\'\"></ng-include>\n<ng-include src=\"\'app/main/projects/templates/inc-project-i-costs.html\'\"></ng-include></md-tab><md-tab label=\"RESUMEN\" \nng-disabled=\"!vm.item.id\"><ng-include src=\"\'app/main/projects/templates/inc-project-resume.html\'\"></ng-include>\n</md-tab></md-tabs></form></div><div class=\"toolbar-footer md-background-bg md-hue-2\"><div class=\"md-toolbar-tools\">\n<md-button ng-click=\"vm.back()\" md-theme=\"buttons\" class=\"md-raised\" aria-label=\"Cancelar\"><span>VOLVER</span>\n</md-button><span flex></span><md-button ng-click=\"vm.save()\" md-theme=\"buttons\" class=\"md-raised md-accent\" \nng-disabled=\"frm.$invalid || vm.saving\" aria-label=\"Guardar\" ng-show=\"vm.showSaveButton && vm.canEdit\"><span \nng-show=\"!vm.saving && vm.item.id\">GUARDAR</span> <span ng-show=\"!vm.saving && !vm.item.id\">GUARDAR Y SEGUIR</span> \n<span ng-show=\"vm.saving\">GUARDANDO...</span></md-button></div></div></div>");
$templateCache.put("app/main/projects/hours/project-hours.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"HorasProyectos\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\"><md-tooltip \nmd-direction=\"top\">Filtrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div>\n<md-button permission permission-only=\"\'cargarHorasProyectos\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-primary action-button\" aria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip \nmd-direction=\"top\">Nuevo</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission \npermission-only=\"\'eliminarHorasProyectos\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \nng-disabled=\"vm.list.selected.length === 0\" aria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip \nmd-direction=\"top\">Eliminar selección</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n<md-sidenav class=\"sidenav main-sidenav\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/projects/hours/sidenavs/filters.html\'\"></md-sidenav><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column md-order-by=\"date\">Fecha</th><th md-column>Proyecto</th><th \nmd-column>Usuario</th><th md-column>Hs</th><th md-column md-order-by=\"created_at\">Fecha de carga</th><th md-column \nclass=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\"><tr md-row md-select=\"item\" \nmd-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell>{{item.date | formatDate}}</td><td md-cell>\n{{item.project.name}}</td><td md-cell>{{item.user_id == vm.me.id ? \'Yo\' : item.user.name}}</td><td md-cell>\n{{item.hours}}</td><td md-cell>{{item.created_at | formatDate: \'DD/MM/YYYY HH:mm:ss\'}}</td><td md-cell \nclass=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button permission \npermission-only=\"\'cargarHorasProyectos\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" \nng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\">\n</md-icon></md-button><md-button permission permission-only=\"\'eliminarHorasProyectos\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip \nmd-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr>\n</tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/projects/stages/stages.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"EtapasProyecto\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearEtapasProyecto\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" \naria-label=\"Nuevo\" ng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarEtapasProyecto\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">Etapa</th><th md-column class=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\">\n<tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}\n</td><td md-cell>{{item.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button\n ng-if=\"item.can_update\" permission permission-only=\"\'editarEtapasProyecto\'\" md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar\n</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button ng-if=\"item.can_delete\" \npermission permission-only=\"\'eliminarEtapasProyecto\'\" md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" \naria-label=\"Editar\" ng-click=\"vm.delete(item)\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container></div>\n<md-table-pagination class=\"md-background-bg md-hue-2\" layout-align=\"space-between center\" \nmd-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" md-page=\"vm.list.query.page\" \nmd-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/projects/templates/inc-project-estimates.html","<md-card><md-card-content class=\"no-padding\"><md-table-container><table md-table class=\"md-table-list\"><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column width=\"50\"></th><th md-column>Nro</th><th md-column>Importe\n</th><th md-column>Archivo</th><th md-column>Descripción</th></tr></thead><tbody md-body class=\"md-background-bg\"><tr \nng-repeat=\"item in vm.item.estimates\"><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><a \nng-href=\"{{ item.full_filename }}\" class=\"md-button md-icon-button no-margin\" aria-label=\"Editar\" target=\"_blank\">\n<md-tooltip md-direction=\"top\">Ver</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></a><md-button \nmd-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.editEstimate(item)\" \nng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon>\n</md-button><md-button md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Eliminar\" \nng-click=\"vm.removeEstimate($index,item)\" ng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></td><td md-cell>{{item.number}}</td><td md-cell>\n{{item.amount | currency}}</td><td md-cell>{{item.real_filename}}</td><td md-cell>{{item.description}}</td></tr>\n</tbody></table></md-table-container></md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\"><div\n layout=\"row\" layout-align=\"start center\" layout-wrap><strong class=\"padding-left-10\">Total:&nbsp;</strong> <span>\n{{ vm.item.estimates_total | currency }}</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.addEstimate()\" aria-label=\"Agregar\" ng-if=\"vm.canEdit\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-button></md-button></md-button></div></md-card-footer></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-i-costs.html","<md-card><md-card-header><span class=\"md-subhead\">Costos Internos</span></md-card-header><md-card-content \nclass=\"no-padding\"><md-table-container><table md-table class=\"md-table-list\"><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column width=\"50\"></th><th md-column>Importe</th><th md-column>\nDescripción</th></tr></thead><tbody md-body class=\"md-background-bg\"><tr \nng-repeat=\"item in vm.item.costs | filter:{ type: \'I\' }\"><td md-cell class=\"c-actions\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button md-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" \nng-click=\"vm.editCost(item)\" ng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" aria-label=\"Eliminar\" ng-click=\"vm.removeCost($index,item)\" \nng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></div></td><td md-cell>{{item.amount}}</td><td md-cell>{{item.description}}</td></tr></tbody></table>\n</md-table-container></md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><strong class=\"padding-left-10\">Total:</strong> <span>\n{{ vm.item.internal_costs | currency }}</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.addCost(\'I\')\" aria-label=\"Agregar\" ng-if=\"vm.canEdit\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-button></md-button></md-button></div></md-card-footer></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-po.html","<md-card><md-card-content class=\"no-padding\"><md-table-container><table md-table class=\"md-table-list\"><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column>Nro OC</th><th md-column>Importe</th><th md-column>\nDescripción</th><th md-column class=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\"><tr \nng-repeat=\"item in vm.item.purchase_orders\"><td md-cell>{{item.number}}</td><td md-cell>{{item.amount}}</td><td \nmd-cell>{{item.description}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><a \nng-href=\"{{ item.full_filename }}\" class=\"md-button md-icon-button no-margin\" aria-label=\"Editar\" target=\"_blank\">\n<md-tooltip md-direction=\"top\">Ver</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></a><md-button \nmd-theme=\"buttons\" class=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.editPO(item)\" \nng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon>\n</md-button><md-button md-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Eliminar\" \nng-click=\"vm.removePO($index,item)\" ng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></td></tr></tbody></table></md-table-container>\n</md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\" ng-if=\"vm.canEdit\"><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.addPO()\" \naria-label=\"Agregar\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-button></md-button></md-button></div>\n</md-card-footer></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-resume.html","<md-card><md-card-content class=\"no-padding\"><md-table-container><table md-table class=\"md-table-list\"><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column>Concepto</th><th md-column md-numeric>Sub Total</th></tr>\n</thead><tbody md-body class=\"md-background-bg\"><tr md-row><td md-cell>Presupuestos</td><td md-cell \nclass=\"green-500-fg\">{{vm.item.estimates_total | currency}}</td></tr><tr md-row><td md-cell>Costos Proveedores</td><td \nmd-cell class=\"red-500-fg\">{{vm.item.supplier_costs * -1 | currency}}</td></tr><tr md-row><td md-cell>Costos Internos\n</td><td md-cell class=\"red-500-fg\">{{vm.item.internal_costs * -1 | currency}}</td></tr></tbody><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column>Rentabilidad bruta</th><th md-column md-numeric \nng-class=\"{\'red-500-fg\': vm.grossProfitability() < 0, \'green-500-fg\': vm.grossProfitability() > 0}\">\n{{vm.grossProfitability() | currency}}</th></tr></thead></table></md-table-container></md-card-content></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-s-costs.html","<md-card><md-card-header><span class=\"md-subhead\">Costos asociados a proveedores</span></md-card-header>\n<md-card-content class=\"no-padding\"><md-table-container><table md-table class=\"md-table-list\"><thead md-head \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column width=\"30\"></th><th md-column>Proveedor</th><th md-column>\nImporte</th><th md-column>Archivo</th><th md-column>Descripción</th></tr></thead><tbody md-body \nclass=\"md-background-bg\"><tr ng-repeat=\"item in vm.item.costs | filter:{ type: \'S\' }\"><td md-cell class=\"c-actions\">\n<div layout=\"row\" layout-align=\"end center\"><a ng-if=\"item.filename\" ng-href=\"{{ item.full_filename }}\" \nclass=\"md-button md-icon-button no-margin\" aria-label=\"Editar\" target=\"_blank\"><md-tooltip md-direction=\"top\">Ver\n</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></a><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Editar\" ng-click=\"vm.editCost(item)\" ng-if=\"vm.canEdit\"><md-tooltip \nmd-direction=\"top\">Editar</md-tooltip><md-icon md-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Eliminar\" \nng-click=\"vm.removeCost($index,item)\" ng-if=\"vm.canEdit\"><md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></td><td md-cell>{{item.supplier.business_name}}</td><td \nmd-cell>{{item.amount}}</td><td md-cell>{{item.real_filename}}</td><td md-cell>{{item.description}}</td></tr></tbody>\n</table></md-table-container></md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><strong class=\"padding-left-10\">Total:&nbsp;</strong> <span>\n{{ vm.item.supplier_costs | currency }}</span> <span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.addCost(\'S\')\" aria-label=\"Agregar\" ng-if=\"vm.canEdit\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-button></md-button></md-button></div></md-card-footer></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-stages.html","<md-card><md-card-header class=\"p-10\"><md-card-header-text><span class=\"h4\">\nAgregue las etapas del proyecto por orden de suceso</span></md-card-header-text></md-card-header><md-divider>\n</md-divider><md-card-content layout-padding><md-list flex=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap>\n<md-list-item ng-repeat=\"stage in vm.item.stages | filter: vm.filterItems\" class=\"noright\" flex=\"100\"><div \nclass=\"md-list-item-text\" layout=\"column\"><span>{{ stage.name }}</span></div><md-button class=\"md-icon-button\" \nng-if=\"$last && vm.canFinish\" ng-click=\"vm.removeItem(stage)\" aria-label=\"Quitar\" class=\"md-secondary md-hue-3\">\n<md-icon md-font-icon=\"icon-trash\" aria-label=\"Quitar\"></md-icon><md-button></md-button></md-button></md-list-item>\n</md-list></md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\" ng-if=\"vm.canEdit\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><md-input-container flex class=\"margin-top-0 padding-left-10\">\n<md-select name=\"stage\" ng-model=\"vm.selectedStage\"><md-option ng-value=\"\"></md-option><md-option \nng-repeat=\"stage in vm.stages\" ng-value=\"stage\" ng-selected=\"{{ vm.selectedStage.id == stage.id }}\">{{stage.name}}\n</md-option></md-select></md-input-container><md-button ng-disabled=\"!vm.selectedStage\" class=\"md-icon-button\" \nng-click=\"vm.addStage()\" aria-label=\"Agregar\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-button></md-button>\n</md-button></div></md-card-footer></md-card>");
$templateCache.put("app/main/projects/templates/inc-project-users.html","<md-card><md-card-header class=\"p-10\"><md-card-header-text><span class=\"h4\">Equipo</span></md-card-header-text>\n</md-card-header><md-divider></md-divider><md-card-content layout-padding><md-list flex=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><md-list-item ng-repeat=\"user in vm.item.users | filter: vm.filterItems\" \nclass=\"noright\" flex=\"100\" flex-gt-xs=\"25\"><div class=\"md-list-item-text\" layout=\"column\"><span>{{ user.name }}</span> \n<span class=\"font-size-10\">{{ user.role.display_name }} - {{ user.area.name }}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.removeItem(user)\" aria-label=\"Quitar\" class=\"md-secondary md-hue-3\" \nng-if=\"vm.canEdit\"><md-icon md-font-icon=\"icon-trash\" aria-label=\"Quitar\"></md-icon><md-button></md-button></md-button>\n</md-list-item></md-list></md-card-content><md-divider></md-divider><md-card-footer class=\"no-padding\" \nng-if=\"vm.canEdit\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><md-autocomplete flex \nmd-input-name=\"acUsers\" md-selected-item=\"vm.acUsers.selectedItem\" md-search-text=\"vm.acUsers.searchText\" \nmd-items=\"item in vm.acUsers.querySearch(vm.acUsers.searchText)\" md-item-text=\"item.name\" md-delay=\"300\" \nmd-min-length=\"3\" placeholder=\"Agregar personal al proyecto\"><div layout=\"row\" class=\"item\" \nlayout-align=\"start center\"><span md-highlight-text=\"vm.acUsers.searchText\">{{item.name}}</span></div><div \nng-messages=\"frm.acUsers.$error\" ng-if=\"frm.acUsers.$touched\"><div ng-message=\"md-require-match\">\nPlease select an existing state.</div></div></md-autocomplete><md-button ng-disabled=\"!vm.acUsers.selectedItem\" \nclass=\"md-icon-button\" ng-click=\"vm.addUser()\" aria-label=\"Agregar\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-button></md-button></md-button></div></md-card-footer></md-card>");
$templateCache.put("app/main/suppliers/cu/cu-suppliers.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-suppliers\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input name=\"business_name\" ng-model=\"vm.item.business_name\" placeholder=\"Razón social\" md-maxlength=\"50\" required><div\n ng-messages=\"frm.business_name.$error\" ng-show=\"frm.business_name.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"cuit\" ng-model=\"vm.item.cuit\" \nplaceholder=\"CUIT/CUIL\" md-maxlength=\"100\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \nname=\"contact_name\" ng-model=\"vm.item.contact_name\" placeholder=\"Contacto principal\" md-maxlength=\"100\" required><div \nng-messages=\"frm.contact_name.$error\" ng-show=\"frm.contact_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" name=\"contact_email\" ng-model=\"vm.item.contact_email\" \nplaceholder=\"E-mail contacto principal\" md-maxlength=\"100\" required><div ng-messages=\"frm.contact_email.$error\" \nng-show=\"frm.contact_email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div>\n<div ng-message=\"email\"><span>El formato del email es incorrecto</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"phone\" ng-model=\"vm.item.phone\" \nplaceholder=\"Teléfono\" md-maxlength=\"20\"></md-input-container></md-card-content></md-card><md-card class=\"check-list\">\n<md-card-header><md-card-header-text><span class=\"h3\">Skills</span></md-card-header-text></md-card-header><md-divider>\n</md-divider><md-card-content class=\"scrollable\" ms-scroll><md-list layout=\"row\" layout-wrap><md-list-item \nng-repeat=\"item in vm.skills\" flex=\"100\" flex-gt-xs=\"25\"><input type=\"checkbox\" checklist-model=\"vm.item.skills\" \nchecklist-value=\"item\"><p class=\"h4\">{{ item.name }}</p><md-divider></md-divider></md-list-item></md-list>\n</md-card-content></md-card></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/suppliers/sidenavs/filters.html","<div ms-scroll class=\"content scrollable\"><md-list class=\"filter-sidenav\"><md-list-item class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div class=\"h4\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"icon\"></md-icon>Filtros</div><span flex></span><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button></div></md-list-item><md-list-item \nclass=\"filter-item\"><div layout=\"column\" layout-align=\"center stretch\" flex=\"100\"><label><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\"></md-icon>Ingrese su busqueda</label><md-input-container \nclass=\"no-errors-spacer\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" placeholder=\"\">\n</md-input-container></div></md-list-item><md-list-item class=\"filter-item\"><div layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><label><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon>Skills</label>\n<md-input-container><md-select multiple=\"multiple\" ng-model=\"vm.list.query.skills\" placeholder=\"\" aria-label=\"Skills\">\n<md-option ng-repeat=\"item in vm.skills\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container>\n</div></md-list-item><md-list-item class=\"filter-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.list.refresh(vmMain,\'sidenav\')\" aria-label=\"Filtrar\">FILTRAR</md-button></md-list-item></md-list></div>");
$templateCache.put("app/main/suppliers/skills/skills.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"Skills\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"filter-bar\" layout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float=\"true\" \nclass=\"no-errors-spacer\" flex=\"100\" flex-gt-xs=\"30\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" \nplaceholder=\"Ingrese su busqueda\"></md-input-container><md-button md-theme=\"buttons\" \nclass=\"md-icon-button action-button\" aria-label=\"Filtrar\" ng-click=\"vm.list.refresh()\"><md-tooltip md-direction=\"top\">\nFiltrar</md-tooltip><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><md-button permission \npermission-only=\"\'crearSkills\'\" md-theme=\"buttons\" class=\"md-icon-button md-primary action-button\" aria-label=\"Nuevo\" \nng-click=\"vm.create()\"><md-tooltip md-direction=\"top\">Nuevo</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button permission permission-only=\"\'eliminarSkills\'\" md-theme=\"buttons\" \nclass=\"md-icon-button md-warn action-button\" ng-disabled=\"vm.list.selected.length === 0\" \naria-label=\"Eliminar selección\" ng-click=\"vm.deleteSelected()\"><md-tooltip md-direction=\"top\">Eliminar selección\n</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><div class=\"scrollable\" ms-scroll flex>\n<md-table-container><table md-table class=\"md-table-list\" ng-model=\"vm.list.selected\" md-progress=\"vm.list.promise\" \nmd-row-select multiple=\"multiple\"><thead md-head md-order=\"vm.list.query.order\" md-on-reorder=\"vm.list.filter\" \nclass=\"md-background-bg md-hue-2\"><tr md-row><th md-column class=\"c-id\" md-order-by=\"id\">ID</th><th md-column \nmd-order-by=\"name\">Skill</th><th md-column class=\"c-actions\"></th></tr></thead><tbody md-body class=\"md-background-bg\">\n<tr md-row md-select=\"item\" md-select-id=\"id\" ng-repeat=\"item in vm.list.items\"><td md-cell class=\"c-id\">{{item.id}}\n</td><td md-cell>{{item.name}}</td><td md-cell class=\"c-actions\"><div layout=\"row\" layout-align=\"end center\"><md-button\n permission permission-only=\"\'editarSkills\'\" md-theme=\"buttons\" class=\"md-icon-button action-button\" \naria-label=\"Editar\" ng-click=\"vm.edit(item)\"><md-tooltip md-direction=\"top\">Editar</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil-box\"></md-icon></md-button><md-button permission permission-only=\"\'eliminarSkills\'\" \nmd-theme=\"buttons\" class=\"md-icon-button md-warn action-button\" aria-label=\"Editar\" ng-click=\"vm.delete(item)\">\n<md-tooltip md-direction=\"top\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</td></tr></tbody></table></md-table-container></div><md-table-pagination class=\"md-background-bg md-hue-2\" \nlayout-align=\"space-between center\" md-limit=\"vm.list.query.limit\" md-label=\"{page: \'Pág:\'}\" \nmd-page=\"vm.list.query.page\" md-total=\"{{ vm.list.totalItems }}\" md-on-paginate=\"vm.list.filter\" md-page-select>\n</md-table-pagination></div>");
$templateCache.put("app/main/users/cu/cu-users.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-users\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex flex-gt-xs=\"50\"><input \nname=\"first_name\" ng-model=\"vm.item.first_name\" placeholder=\"Nombre\" md-maxlength=\"50\" required><div \nng-messages=\"frm.first_name.$error\" ng-show=\"frm.first_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex flex-gt-xs=\"50\"><input name=\"last_name\" ng-model=\"vm.item.last_name\" placeholder=\"Apellido\" md-maxlength=\"50\" \nrequired><div ng-messages=\"frm.last_name.$error\" ng-show=\"frm.last_name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div>\n</md-input-container><md-input-container flex flex-gt-xs=\"50\"><input name=\"email\" ng-model=\"vm.item.email\" \nplaceholder=\"Email\" md-maxlength=\"80\" required><div ng-messages=\"frm.email.$error\" ng-show=\"frm.email.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div><div ng-message=\"email\"><span>\nEl formato del email es incorrecto</span></div></div></md-input-container></md-card-content></md-card><md-card \nng-if=\"!vm.item.id\"><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex \nflex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"vm.item.password\" placeholder=\"Password\" \nmd-maxlength=\"20\" required=\"!vm.item.id\"><div ng-messages=\"frm.password.$error\" ng-show=\"frm.password.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div>\n</div></md-input-container><md-input-container flex flex-gt-xs=\"50\"><input type=\"password\" name=\"confirm_password\" \nng-model=\"vm.item.confirm_password\" placeholder=\"Confirmar password\" md-maxlength=\"20\" compare-to=\"vm.item.password\">\n<div ng-messages=\"frm.confirm_password.$error\" ng-show=\"frm.confirm_password.$touched\" role=\"alert\"><div \nng-message=\"compareTo\"><span>Las contraseñas no coinciden</span></div></div></md-input-container></md-card-content>\n</md-card><md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex \nflex-gt-xs=\"50\"><label>Área</label><md-select name=\"area\" ng-model=\"vm.item.area\" required><md-option \nng-repeat=\"option in ::vm.areas\" ng-value=\"option\" ng-selected=\"{{ vm.item.area.id === option.id }}\">{{option.name}}\n</md-option></md-select><div ng-messages=\"frm.area.$error\" ng-show=\"frm.area.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div>\n</md-input-container><md-input-container flex flex-gt-xs=\"50\"><label>Rol</label><md-select name=\"role\" \nng-model=\"vm.item.role\" required><md-option ng-repeat=\"option in vm.roles\" ng-value=\"option\" \nng-selected=\"{{ vm.item.role.id === option.id }}\">{{option.display_name}}</md-option></md-select><div \nng-messages=\"frm.role.$error\" ng-show=\"frm.role.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container></md-card-content>\n</md-card></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/users/sidenavs/filters.html","<div ms-scroll class=\"content scrollable\"><md-list class=\"filter-sidenav\"><md-list-item class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div class=\"h4\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"icon\"></md-icon>Filtros</div><span flex></span><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button></div></md-list-item><md-list-item \nclass=\"filter-item\"><div layout=\"column\" layout-align=\"center stretch\" flex=\"100\"><label><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\"></md-icon>Ingrese su busqueda</label><md-input-container \nclass=\"no-errors-spacer\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" placeholder=\"\">\n</md-input-container></div></md-list-item><md-list-item class=\"filter-item\"><div layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><label><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon>Roles</label>\n<md-input-container><md-select multiple=\"multiple\" ng-model=\"vm.list.query.roles\" placeholder=\"\" aria-label=\"Roles\">\n<md-option ng-repeat=\"item in vm.roles\" ng-value=\"item.id\">{{item.display_name}}</md-option></md-select>\n</md-input-container></div></md-list-item><md-list-item class=\"filter-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.list.refresh(vmMain,\'sidenav\')\" aria-label=\"Filtrar\">FILTRAR</md-button></md-list-item></md-list></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<div layout=\"row\" layout-align=\"space-between end\" layout-padding class=\"md-accent-bg\"><div layout=\"column\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\"><strong>{{ vm.currentUser.name }}</strong><br>{{ vm.currentUser.email }}</span></div><div flex></div>\n<md-menu md-position-mode=\"right bottom\" flex><md-button ng-click=\"$mdOpenMenu()\" aria-label=\"Mas\" \nclass=\"no-padding no-margin w-30\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"icon white-fg\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.openChangePasswordDialog()\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>Cambiar password</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.logout()\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon>Logout</md-button></md-menu-item></md-menu-content></md-menu></div>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" hide-gt-sm><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\">\n</md-icon></md-button></div><div flex></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Lucas</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-background-bg md-hue-3\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/admin/areas/cu/cu-areas.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-areas\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input name=\"name\" ng-model=\"vm.item.name\" placeholder=\"Área\" md-maxlength=\"100\" required md-autofocus><div \nng-messages=\"frm.name.$error\" ng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Responsable</label><md-select name=\"user\" ng-model=\"vm.item.user\"><md-option \nng-value=\"\">Ninguno</md-option><md-option ng-repeat=\"option in vm.users\" ng-value=\"option\" \nng-selected=\"{{ vm.item.user_id === option.id }}\">{{option.name}}</md-option></md-select></md-input-container>\n</md-card-content></md-card><md-card><md-card-content><md-input-container class=\"md-block\"><textarea \nname=\"description\" ng-model=\"vm.item.description\" placeholder=\"Descripción\" md-maxlength=\"150\" rows=\"5\"></textarea>\n</md-input-container></md-card-content></md-card></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/auth/permissions/cu/cu-permissions.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-permissions\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-content class=\"md-whiteframe-1dp md-background-bg\" layout=\"column\" flex><div flex layout=\"row\" layout-xs=\"column\" \nlayout-wrap layout-padding><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Grupo</label><input name=\"group\" \nng-model=\"vm.item.group\" placeholder=\"  \" ng-change=\"vm.makeKey()\" md-maxlength=\"50\" required md-autofocus><div \nng-messages=\"frm.group.$error\" ng-show=\"frm.group.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nEl campo es obligatorio</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nPermiso</label><input name=\"display_name\" ng-model=\"vm.item.display_name\" placeholder=\"  \" ng-change=\"vm.makeKey()\" \nmd-maxlength=\"50\" required md-autofocus><div ng-messages=\"frm.display_name.$error\" ng-show=\"frm.display_name.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Key</label><input name=\"name\" \nng-model=\"vm.item.name\" placeholder=\"  \" ng-disabled=\"true\"></md-input-container></div></md-content><md-content \nclass=\"md-whiteframe-1dp md-background-bg\" flex layout-padding><md-input-container class=\"md-block\"><label>Descripción\n</label><textarea name=\"description\" ng-model=\"vm.item.description\" placeholder=\" \" md-maxlength=\"150\" rows=\"5\">\n</textarea></md-input-container></md-content></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/auth/roles/cu/cu-roles.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-roles\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap layout-padding><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Rol</label><input name=\"display_name\" ng-model=\"vm.item.display_name\" placeholder=\"  \" \nng-change=\"vm.makeKey()\" md-maxlength=\"50\" required md-autofocus><div ng-messages=\"frm.display_name.$error\" \nng-show=\"frm.display_name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">\nEl campo es obligatorio</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>\nKey</label><input name=\"name\" ng-model=\"vm.item.name\" placeholder=\"  \" ng-disabled=\"true\"></md-input-container>\n</md-card-content></md-card><md-card class=\"check-list\"><md-card-header><md-card-header-text><span class=\"md-subhead\">\nPermisos</span></md-card-header-text><md-card-header-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-small md-accent no-margin\" ng-click=\"vm.selectAll(true)\">Todos</md-button><md-button \nclass=\"md-small md-warn no-margin\" ng-click=\"vm.selectAll(false)\">Ninguno</md-button></md-card-header-actions>\n</md-card-header><md-divider></md-divider><md-card-content class=\"scrollable\" ms-scroll><md-list layout=\"row\" \nlayout-wrap ng-repeat=\"(key, value) in vm.permissions | groupBy: \'group\'\"><md-subheader flex=\"100\">{{ key }}\n</md-subheader><md-list-item ng-repeat=\"item in value\" flex=\"100\" flex-gt-xs=\"25\"><input type=\"checkbox\" \nchecklist-model=\"vm.item.permissions\" checklist-value=\"item\"><p class=\"h5\">{{ item.display_name }}</p><md-divider>\n</md-divider></md-list-item></md-list></md-card-content></md-card><md-card><md-card-content><md-input-container \nclass=\"md-block\"><label>Descripción</label><textarea name=\"description\" ng-model=\"vm.item.description\" placeholder=\" \" \nmd-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></md-card-content></md-card></form></div><cu-footer>\n</cu-footer></div>");
$templateCache.put("app/main/customers/brands/cu/cu-brands.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-marcas\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"row\" layout-wrap><div \nflex=\"100\"><md-card><md-card-content layout=\"row\" layout-xs=\"column\"><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input name=\"name\" ng-model=\"vm.item.name\" placeholder=\"Nombre\" md-maxlength=\"50\" required><div \nng-messages=\"frm.name.$error\" ng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Empresa</label><md-select name=\"company_id\" ng-model=\"vm.item.company_id\" required>\n<md-option ng-value=\"\">Seleccionar</md-option><md-option ng-repeat=\"option in vm.companies\" ng-value=\"option.id\" \nng-selected=\"{{ vm.item.company_id == option.id }}\">{{option.name}}</md-option></md-select><div \nng-messages=\"frm.company_id.$error\" ng-show=\"frm.company_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container></md-card-content>\n</md-card></div><div flex=\"100\" flex-gt-xs=\"50\"><md-card><md-card-header class=\"padding-10\"><span class=\"subtitle\">\nContacto principal</span></md-card-header><md-divider></md-divider><md-card-content layout=\"column\"><md-input-container\n flex=\"100\" flex-gt-xs=\"50\"><input name=\"contact_name\" ng-model=\"vm.item.contact_name\" placeholder=\"Nombre\" \nmd-maxlength=\"50\" required><div ng-messages=\"frm.contact_name.$error\" ng-show=\"frm.contact_name.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input name=\"contact_email\" ng-model=\"vm.item.contact_email\" placeholder=\"Email\" \nmd-maxlength=\"100\"></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input name=\"contact_phone\" \nng-model=\"vm.item.contact_phone\" placeholder=\"Teléfono\" md-maxlength=\"20\"></md-input-container></md-card-content>\n</md-card></div><div flex=\"100\" flex-gt-xs=\"50\"><md-card><md-card-header class=\"padding-10\"><span class=\"title\">Agencia\n</span></md-card-header><md-divider></md-divider><md-card-content layout=\"column\"><md-input-container flex=\"100\">\n<label>Responsable</label><md-select name=\"user_id\" ng-model=\"vm.item.user_id\" required><md-option ng-value=\"\">\nSeleccionar</md-option><md-option ng-repeat=\"option in vm.users\" ng-value=\"option.id\" \nng-selected=\"{{ vm.item.user_id == option.id }}\">{{option.name}}</md-option></md-select><div \nng-messages=\"frm.user_id.$error\" ng-show=\"frm.user_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\"><textarea name=\"observations\" ng-model=\"vm.item.observations\" placeholder=\"Observaciones\" rows=\"5\">\n</textarea></md-input-container></md-card-content></md-card></div></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/customers/brands/sidenav/filters.html","<div ms-scroll class=\"content scrollable\"><md-list class=\"filter-sidenav\"><md-list-item class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div class=\"h4\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"icon\"></md-icon>Filtros</div><span flex></span><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button></div></md-list-item><md-list-item \nclass=\"filter-item\"><div layout=\"column\" layout-align=\"center stretch\" flex=\"100\"><label><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\"></md-icon>Ingrese su busqueda</label><md-input-container \nclass=\"no-errors-spacer\"><input type=\"text\" name=\"search\" ng-model=\"vm.list.query.search\" placeholder=\"\">\n</md-input-container></div></md-list-item><md-list-item class=\"filter-item\"><div layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><label><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon>Empresa\n</label><md-input-container><md-select ng-model=\"vm.list.query.company_id\" placeholder=\"\"><md-option ng-value=\"\" \nng-selected=\"{{ !vm.list.query.company_id }}\">Todas</md-option><md-option ng-repeat=\"item in vm.companies\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div></md-list-item><md-list-item \nclass=\"filter-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.list.refresh(vmMain,\'sidenav\')\">FILTRAR\n</md-button></md-list-item></md-list></div>");
$templateCache.put("app/main/customers/companies/cu/cu-companies.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-companies\"><div layout=\"row\" \nlayout-align=\"space-between center\" layout-padding class=\"md-accent-bg md-whiteframe-1dp\"><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vm.back()\" aria-label=\"Volver\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button><div layout=\"column\"><span class=\"md-title\">\n{{ vm.title }}</span><h6 class=\"no-margin\" ng-if=\"vm.subtitle\">{{vm.subtitle}}</h6></div><span flex></span></div><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\"><md-card>\n<md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex><input name=\"name\" \nng-model=\"vm.item.name\" placeholder=\"Nombre\" md-maxlength=\"100\" required><div ng-messages=\"frm.name.$error\" \nng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">\nEl campo es obligatorio</span></div></div></md-input-container></md-card-content></md-card><div \nng-if=\"vm.item.brands.length > 0\" class=\"md-title mt-48\">Marcas</div><div ng-if=\"vm.item.brands.length > 0\" \nlayout=\"row\" layout-gt-xs=\"row\" layout-wrap><div flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" \nng-repeat=\"brand in vm.item.brands\"><md-card><md-card-content layout=\"column\"><span class=\"md-title\" flex>\n{{ brand.name }}</span> <small flex>{{ brand.contact_name }} (<em>{{ brand.contact_email }}</em>)</small> <small><mark>\nResponsable:</mark> <em>{{ brand.responsible.name }}</em></small></md-card-content></md-card></div></div></form></div>\n<cu-footer></cu-footer></div>");
$templateCache.put("app/main/projects/dialogs/costs/cu-costs.html","<md-dialog aria-label=\"Orden de compra\" flex=\"66\"><form class=\"md-inline-form\" name=\"frm\"><md-toolbar \nclass=\"md-accent md-hue-2\" md-theme=\"toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll layout=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Importe</label>\n<input name=\"amount\" na ng-model=\"vm.item.amount\" type=\"numeric\" required><div ng-messages=\"frm.amount.$error\" \nng-show=\"frm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div></div>\n</md-input-container><md-autocomplete flex=\"100\" flex-gt-xs=\"50\" ng-if=\"vm.item.type === \'S\'\" md-input-name=\"supplier\" \nmd-selected-item=\"vm.item.supplier\" md-search-text=\"vm.searchSupplierText\" \nmd-items=\"item in vm.querySupplierSearch(vm.searchSupplierText)\" md-item-text=\"item.business_name\" md-delay=\"300\" \nmd-min-length=\"3\" placeholder=\"Seleccione al proovedor...\" md-require-match md-floating-label=\"Proveedor\" required><div\n layout=\"row\" class=\"item\" layout-align=\"start center\"><span md-highlight-text=\"vm.searchSupplierText\">\n{{item.business_name}}</span></div><div ng-messages=\"frm.supplier.$error\" ng-if=\"frm.supplier.$touched\"><div \nng-message=\"md-require-match\">Seleccione un proveedor existente.</div></div></md-autocomplete><div layout=\"row\" \nlayout-align=\"center start\" flex=\"100\" ng-if=\"vm.item.type === \'S\'\" layout-wrap><label flex=\"100\">Archivo</label><input\n flex=\"100\" type=\"text\" ng-disabled=\"true\" ng-if=\"vm.item.real_filename\" name=\"real_filename\" \nng-model=\"vm.item.real_filename\"><md-button flex ngf-select ng-model=\"vm.item.newFile\" ngf-multiple=\"false\" \nmd-theme=\"buttons\" class=\"md-accent md-raised\" aria-label=\"Seleccionar\">Seleccionar</md-button></div>\n<md-input-container flex=\"100\"><label>Descripción</label><textarea name=\"description\" ng-model=\"vm.item.description\" \nrows=\"5\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div flex></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.save(frm)\" ng-disabled=\"frm.$invalid\" md-theme=\"buttons\" class=\"send-button md-accent md-raised\" \naria-label=\"Guardar\">GUARDAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/projects/dialogs/estimates/cu-estimates.html","<md-dialog aria-label=\"Orden de compra\" flex=\"66\"><form class=\"md-inline-form\" name=\"frm\"><md-toolbar \nclass=\"md-accent md-hue-2\" md-theme=\"toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll layout=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Importe</label>\n<input name=\"amount\" na ng-model=\"vm.item.amount\" type=\"numeric\" required><div ng-messages=\"frm.amount.$error\" \nng-show=\"frm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div></div>\n</md-input-container><md-input-container flex=\"50\"><label>Nro</label><input name=\"number\" ng-model=\"vm.item.number\" \ntype=\"text\" required><div ng-messages=\"frm.number.$error\" ng-show=\"frm.number.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\"><input type=\"text\" ng-disabled=\"true\" name=\"real_filename\" ng-model=\"vm.item.real_filename\"><md-button \nngf-select ng-model=\"vm.item.newFile\" ngf-multiple=\"false\" md-theme=\"buttons\" class=\"md-accent md-raised\" \naria-label=\"Seleccionar\">Seleccionar</md-button></md-input-container><md-input-container flex=\"100\"><label>Descripción\n</label><textarea name=\"description\" ng-model=\"vm.item.description\" placeholder=\" \" rows=\"5\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div flex>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.save(frm)\" ng-disabled=\"frm.$invalid\" \nmd-theme=\"buttons\" class=\"send-button md-accent md-raised\" aria-label=\"Guardar\">GUARDAR</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/projects/dialogs/po/cu-purchase-order.html","<md-dialog aria-label=\"Orden de compra\" flex=\"66\"><form class=\"md-inline-form\" name=\"frm\"><md-toolbar \nclass=\"md-accent md-hue-2\" md-theme=\"toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll layout=\"row\" layout-wrap><md-input-container flex=\"50\"><label>Importe</label>\n<input name=\"amount\" na ng-model=\"vm.item.amount\" type=\"numeric\" required><div ng-messages=\"frm.amount.$error\" \nng-show=\"frm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div></div>\n</md-input-container><md-input-container flex=\"50\"><label>Nro OC</label><input name=\"number\" ng-model=\"vm.item.number\" \ntype=\"text\"></md-input-container><md-input-container flex=\"100\"><input type=\"text\" ng-disabled=\"true\" \nname=\"real_filename\" ng-model=\"vm.item.real_filename\"><md-button ngf-select ng-model=\"vm.item.newFile\" \nngf-multiple=\"false\" md-theme=\"buttons\" class=\"md-accent md-raised\" aria-label=\"Seleccionar\">Seleccionar</md-button>\n</md-input-container><md-input-container flex=\"100\"><label>Descripción</label><textarea name=\"description\" \nng-model=\"vm.item.description\" placeholder=\" \" rows=\"5\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div flex></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save(frm)\" ng-disabled=\"frm.$invalid\" md-theme=\"buttons\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Guardar\">GUARDAR</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/projects/hours/sidenavs/filters.html","<div ms-scroll class=\"content scrollable\"><md-list class=\"filter-sidenav\"><md-list-item class=\"md-accent-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" layout-padding flex=\"100\"><div class=\"h4\"><md-icon \nmd-font-icon=\"icon-filter\" class=\"icon\"></md-icon>Filtros</div><span flex></span><md-button \nclass=\"md-icon-button no-margin no-padding\" ng-click=\"vmMain.toggleSidenav(\'sidenav\')\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold\" class=\"icon\"></md-icon></md-button></div></md-list-item><md-list-item \nclass=\"filter-item\"><div layout=\"column\" layout-align=\"center stretch\" flex=\"100\"><label><md-icon \nmd-font-icon=\"icon-label\" class=\"s16\"></md-icon>Fecha Desde</label><md-input-container flex=\"50\" flex-gt-xs=\"30\">\n<md-datepicker ng-model=\"vm.list.query.from_date\" name=\"from_date\"></md-datepicker><div \nng-messages=\"frm.from_date.$error\" role=\"alert\"><span ng-message=\"valid\">Fecha incorrecta</span></div>\n</md-input-container></div></md-list-item><md-list-item class=\"filter-item\"><div layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><label><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon>Fecha Hasta\n</label><md-input-container flex=\"50\" flex-gt-xs=\"30\"><md-datepicker ng-model=\"vm.list.query.to_date\" name=\"to_date\">\n</md-datepicker><div ng-messages=\"frm.to_date.$error\" role=\"alert\"><span ng-message=\"valid\">Fecha incorrecta</span>\n</div></md-input-container></div></md-list-item><md-list-item class=\"filter-item\"><div layout=\"column\" \nlayout-align=\"center stretch\" flex=\"100\"><label><md-icon md-font-icon=\"icon-label\" class=\"s16\"></md-icon>Proyectos\n</label><md-input-container><md-select name=\"project\" ng-model=\"vm.list.query.project_id\" aria-label=\"Proyectos\">\n<md-option ng-value=\"0\">Todos</md-option><md-option ng-repeat=\"option in vm.filters.projects\" ng-value=\"option.id\">\n{{option.name}}</md-option></md-select></md-input-container></div></md-list-item><md-list-item class=\"filter-button\">\n<md-button class=\"md-accent md-raised\" ng-click=\"vm.list.refresh(vmMain,\'sidenav\')\" aria-label=\"Filtrar\">FILTRAR\n</md-button></md-list-item></md-list></div>");
$templateCache.put("app/main/projects/stages/cu/cu-stages.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-stages\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex=\"100\"><input \nname=\"name\" ng-model=\"vm.item.name\" placeholder=\"Etapa\" md-maxlength=\"100\" required md-autofocus><div \nng-messages=\"frm.name.$error\" ng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VALIIDATIONS.REQUIRED\">El campo es obligatorio</span></div></div></md-input-container></md-card-content>\n</md-card></form></div><cu-footer></cu-footer></div>");
$templateCache.put("app/main/suppliers/skills/cu/cu-skills.html","<div class=\"page-layout carded fullwidth\" layout=\"column\" id=\"cu-skills\"><cu-header vm=\"vm\"></cu-header><div \nclass=\"scrollable\" ms-scroll flex><form name=\"frm\" class=\"md-inline-form\" novalidate layout=\"column\" layout-margin>\n<md-card><md-card-content layout=\"row\" layout-xs=\"column\" layout-wrap><md-input-container flex><input name=\"name\" \nng-model=\"vm.item.name\" placeholder=\"Skill\" md-maxlength=\"50\" required><div ng-messages=\"frm.name.$error\" \nng-show=\"frm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"VALIIDATIONS.REQUIRED\">\nEl campo es obligatorio</span></div></div></md-input-container></md-card-content></md-card></form></div><cu-footer>\n</cu-footer></div>");
$templateCache.put("app/main/users/dialogs/cp/cp-users.html","<md-dialog aria-label=\"Cambiar password\"><form class=\"md-inline-form\" name=\"frm\"><md-toolbar \nclass=\"md-accent md-hue-2\" md-theme=\"toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Cambiar password</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>Password actual</label><input \nname=\"password\" ng-model=\"vm.form.password\" type=\"text\" required><div ng-messages=\"frm.password.$error\" \nng-show=\"frm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Nueva password</label><input \nname=\"new_password\" na ng-model=\"vm.form.new_password\" type=\"text\" required><div ng-messages=\"frm.new_password.$error\" \nng-show=\"frm.new_password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>El campo es obligatorio</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Reingrese password</label><input \nname=\"confirm_password\" ng-model=\"vm.form.confirm_password\" type=\"text\" required compare-to=\"vm.form.new_password\"><div\n ng-messages=\"frm.confirm_password.$error\" ng-show=\"frm.confirm_password.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>El campo es obligatorio</span></div><div ng-message=\"compareTo\"><span>\nLas contraseñas no coinciden</span></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div flex></div><div layout=\"row\" layout-align=\"end center\"><md-button\n ng-click=\"vm.submit(frm)\" ng-disabled=\"frm.$invalid\" md-theme=\"buttons\" class=\"send-button md-accent md-raised\" \naria-label=\"Cambiar\">CAMBIAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/projects/hours/dialogs/cu/cu-hours.html","<md-dialog aria-label=\"Orden de compra\" flex=\"66\"><form class=\"md-inline-form\" name=\"frm\"><md-toolbar \nclass=\"md-accent md-hue-2\" md-theme=\"toolbar\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.title }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll layout=\"row\" layout-align=\"space-between\" layout-wrap layout-padding>\n<md-input-container flex=\"100\"><label>Usuario</label><md-select name=\"user\" ng-model=\"vm.item.user\" \nng-disabled=\"vm.item.id\" ng-change=\"vm.changeUser()\" required><md-option ng-repeat=\"option in vm.users\" \nng-value=\"option\" ng-selected=\"{{ vm.item.user.id === option.id }}\">{{option.id === vm.me.id ? \'Yo\' : option.name}}\n</md-option></md-select><div ng-messages=\"frm.user.$error\" ng-show=\"frm.user.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>El campo es obligatorio</span></div></div></md-input-container><md-input-container \nflex=\"100\"><label>Proyecto</label><md-select name=\"project\" ng-model=\"vm.item.project\" ng-disabled=\"vm.item.id\" \nrequired><md-option ng-repeat=\"option in vm.projects\" ng-value=\"option\" \nng-selected=\"{{ vm.item.project.id === option.id }}\">{{option.name}}</md-option></md-select><div \nng-messages=\"frm.project.$error\" ng-show=\"frm.project.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nEl campo es obligatorio</span></div></div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"30\" \nmd-no-asterisk><md-datepicker ng-model=\"vm.item.date\" name=\"date\" placeholder=\"Fecha\" md-hide-icons=\"calendar\" \nrequired></md-datepicker><div ng-messages=\"frm.date.$error\" role=\"alert\"><span ng-message=\"required\">\nEl campo es obligatorio</span> <span ng-message=\"valid\">Fecha incorrecta</span></div></md-input-container>\n<md-input-container flex=\"50\" flex-gt-xs=\"30\"><label>Hs</label><md-select name=\"hours\" ng-model=\"vm.item.hours\" \nrequired><md-option ng-repeat=\"option in vm.hours\" ng-value=\"option\" ng-selected=\"{{ vm.item.hours == option }}\">\n{{option}}</md-option></md-select><div ng-messages=\"frm.hours.$error\" ng-show=\"frm.hours.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>El campo es obligatorio</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div flex></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.save(frm)\" ng-disabled=\"frm.$invalid\" md-theme=\"buttons\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Guardar\">GUARDAR</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);